var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBusniessImg3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 430,
    viewBox: "0 0 320 430",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2150_629)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 312,
    height: 422,
    rx: 24,
    fill: "url(#paint0_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.291 148.932L209.281 152.708C209.275 154.51 208.091 156.309 205.724 157.685C200.961 160.453 193.215 160.453 188.42 157.685C186.007 156.292 184.802 154.464 184.808 152.638L184.818 148.862C184.813 150.687 186.018 152.516 188.431 153.909C193.226 156.677 200.971 156.677 205.735 153.909C208.102 152.534 209.286 150.734 209.291 148.932Z",
    fill: "url(#paint1_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.678 143.885C210.473 146.654 210.498 151.14 205.735 153.908C200.971 156.677 193.225 156.677 188.43 153.908C183.636 151.14 183.611 146.654 188.374 143.885C193.138 141.118 200.884 141.117 205.678 143.885Z",
    fill: "url(#paint2_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.291 142.491L209.281 146.267C209.275 148.069 208.091 149.868 205.724 151.243C200.961 154.012 193.215 154.012 188.42 151.243C186.007 149.85 184.802 148.022 184.808 146.197L184.818 142.421C184.813 144.246 186.018 146.075 188.431 147.468C193.226 150.236 200.971 150.236 205.735 147.468C208.102 146.092 209.286 144.293 209.291 142.491Z",
    fill: "url(#paint3_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.678 137.445C210.473 140.213 210.498 144.699 205.735 147.468C200.971 150.237 193.225 150.237 188.43 147.468C183.636 144.7 183.611 140.214 188.374 137.445C193.138 134.677 200.884 134.677 205.678 137.445Z",
    fill: "url(#paint4_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.291 136.05L209.281 139.826C209.275 141.628 208.091 143.428 205.724 144.803C200.961 147.571 193.215 147.571 188.42 144.803C186.007 143.41 184.802 141.582 184.808 139.757L184.818 135.981C184.813 137.806 186.018 139.635 188.431 141.027C193.226 143.795 200.971 143.795 205.735 141.027C208.102 139.652 209.286 137.852 209.291 136.05Z",
    fill: "url(#paint5_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.678 131.004C210.473 133.772 210.498 138.258 205.735 141.027C200.971 143.795 193.225 143.795 188.43 141.027C183.636 138.258 183.611 133.772 188.374 131.004C193.138 128.235 200.884 128.235 205.678 131.004Z",
    fill: "url(#paint6_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.797 155.889L235.787 159.664C235.782 161.466 234.597 163.266 232.231 164.641C227.467 167.41 219.721 167.41 214.927 164.641C212.514 163.248 211.309 161.42 211.314 159.594L211.324 155.819C211.319 157.644 212.524 159.472 214.937 160.865C219.732 163.634 227.477 163.634 232.241 160.865C234.608 159.49 235.792 157.691 235.797 155.889Z",
    fill: "url(#paint7_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.185 150.842C236.98 153.611 237.005 158.097 232.241 160.865C227.478 163.634 219.732 163.634 214.937 160.865C210.142 158.097 210.117 153.611 214.88 150.842C219.645 148.074 227.39 148.074 232.185 150.842Z",
    fill: "url(#paint8_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.797 149.448L235.787 153.224C235.782 155.026 234.597 156.826 232.231 158.201C227.467 160.969 219.721 160.969 214.927 158.201C212.514 156.808 211.309 154.98 211.314 153.154L211.324 149.378C211.319 151.203 212.524 153.032 214.937 154.424C219.732 157.193 227.477 157.193 232.241 154.424C234.608 153.05 235.792 151.25 235.797 149.448Z",
    fill: "url(#paint9_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.185 144.401C236.98 147.17 237.005 151.656 232.241 154.425C227.478 157.193 219.732 157.193 214.937 154.425C210.142 151.657 210.117 147.17 214.88 144.402C219.645 141.633 227.39 141.633 232.185 144.401Z",
    fill: "url(#paint10_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.797 143.007L235.787 146.783C235.782 148.585 234.597 150.384 232.231 151.76C227.467 154.528 219.721 154.528 214.927 151.76C212.514 150.366 211.309 148.538 211.314 146.713L211.324 142.938C211.319 144.763 212.524 146.591 214.937 147.984C219.732 150.752 227.477 150.752 232.241 147.984C234.608 146.609 235.792 144.809 235.797 143.007Z",
    fill: "url(#paint11_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.185 137.961C236.98 140.729 237.005 145.215 232.241 147.984C227.478 150.752 219.732 150.752 214.937 147.984C210.142 145.215 210.117 140.729 214.88 137.961C219.645 135.192 227.39 135.192 232.185 137.961Z",
    fill: "url(#paint12_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.582 256.781L148.202 288.991",
    stroke: "#113F93",
    strokeWidth: 1.8707,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.86 295.114L215.768 268.807",
    stroke: "#A59DF6",
    strokeWidth: 1.8707,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.986 238.764L189.534 184.571",
    stroke: "#113F93",
    strokeWidth: 1.8707,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100.868,
    cy: 179.068,
    r: 0.541591,
    fill: "#A59DF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.615 180.816L239.608 267.349",
    stroke: "#123B90",
    strokeWidth: 1.8707,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.982,
    cy: 268.223,
    r: 0.541591,
    fill: "#A59DF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.229 209.365L153.681 236.416C151.516 237.674 147.998 237.674 145.819 236.416L98.9667 209.365C97.87 208.733 97.3228 207.902 97.3251 207.073L97.3037 214.625C97.3014 215.454 97.8492 216.285 98.9452 216.918L145.798 243.969C147.976 245.227 151.495 245.227 153.66 243.969L200.207 216.918C201.283 216.293 201.821 215.475 201.823 214.657L201.845 207.104C201.843 207.923 201.304 208.74 200.229 209.365Z",
    fill: "url(#paint13_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.203 204.811C202.382 206.069 202.394 208.107 200.229 209.365L153.681 236.416C151.516 237.674 147.998 237.674 145.819 236.416L98.9664 209.365C96.7875 208.107 96.776 206.07 98.9409 204.811L145.489 177.761C147.654 176.502 151.172 176.502 153.351 177.761L200.203 204.811Z",
    fill: "url(#paint14_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.907 206.703L153.064 226.952C151.444 227.893 148.81 227.893 147.179 226.952L112.109 206.704C111.288 206.23 110.878 205.608 110.88 204.988L110.864 208.067C110.862 208.688 111.272 209.31 112.092 209.784L147.163 230.032C148.794 230.973 151.427 230.973 153.048 230.032L187.891 209.783C188.696 209.315 189.099 208.703 189.1 208.091L189.117 205.011C189.115 205.623 188.712 206.235 187.907 206.703Z",
    fill: "url(#paint15_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.888 203.294C189.519 204.236 189.528 205.762 187.907 206.703L153.064 226.952C151.444 227.893 148.81 227.893 147.179 226.952L112.109 206.704C110.478 205.762 110.469 204.236 112.09 203.295L146.933 183.046C148.553 182.105 151.187 182.105 152.818 183.046L187.888 203.294Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.134 217.598C151.883 218.321 150.521 218.918 149.047 219.391C147.558 219.855 146.195 220.135 144.959 220.229L143.463 217.947C144.609 217.835 145.793 217.607 147.014 217.263C148.235 216.902 149.315 216.451 150.253 215.909C150.968 215.496 151.474 215.127 151.772 214.8C152.069 214.456 152.196 214.151 152.151 213.884C152.107 213.618 151.921 213.39 151.593 213.201C151.176 212.96 150.685 212.866 150.119 212.917C149.538 212.96 148.905 213.093 148.22 213.317C147.52 213.532 146.776 213.79 145.987 214.091C145.198 214.375 144.371 214.645 143.507 214.903C142.659 215.153 141.803 215.337 140.939 215.458C140.075 215.578 139.204 215.582 138.326 215.471C137.462 215.35 136.613 215.049 135.779 214.568C134.886 214.052 134.313 213.446 134.059 212.75C133.806 212.036 133.948 211.275 134.484 210.467C135.02 209.642 136.025 208.803 137.499 207.952C138.482 207.385 139.569 206.895 140.76 206.482C141.936 206.061 143.12 205.773 144.311 205.618L145.942 207.849C144.795 208.03 143.761 208.275 142.837 208.584C141.899 208.885 141.08 209.238 140.38 209.642C139.681 210.046 139.189 210.424 138.906 210.777C138.623 211.129 138.519 211.439 138.594 211.705C138.653 211.963 138.854 212.191 139.197 212.389C139.599 212.621 140.09 212.715 140.671 212.672C141.237 212.621 141.862 212.483 142.547 212.26C143.232 212.036 143.969 211.782 144.758 211.499C145.562 211.206 146.381 210.931 147.215 210.673C148.064 210.407 148.92 210.213 149.784 210.093C150.647 209.973 151.511 209.973 152.375 210.093C153.253 210.205 154.102 210.497 154.921 210.97C155.799 211.477 156.358 212.083 156.596 212.788C156.834 213.493 156.685 214.258 156.149 215.084C155.628 215.9 154.623 216.739 153.134 217.598ZM169.097 208.072L166.752 206.718L166.015 206.55L161.816 204.126C161.071 203.696 160.26 203.494 159.381 203.52C158.518 203.537 157.617 203.816 156.679 204.358C156.038 204.728 155.51 205.153 155.093 205.635C154.676 206.099 154.423 206.555 154.333 207.002L150.648 206.318C150.842 205.674 151.273 205.012 151.943 204.332C152.613 203.653 153.425 203.038 154.378 202.488C156.21 201.431 158.063 200.859 159.94 200.773C161.816 200.687 163.67 201.173 165.501 202.23L172.358 206.189L169.097 208.072ZM165.613 210.29C164.675 210.832 163.714 211.206 162.732 211.412C161.734 211.61 160.781 211.653 159.873 211.541C158.964 211.429 158.168 211.176 157.483 210.78C156.768 210.368 156.314 209.908 156.12 209.4C155.942 208.885 156.083 208.322 156.545 207.711C156.991 207.092 157.825 206.43 159.046 205.725L162.24 203.881L164.273 205.054L161.458 206.679C160.639 207.152 160.208 207.556 160.163 207.892C160.133 208.218 160.319 208.498 160.721 208.73C161.168 208.988 161.697 209.095 162.307 209.052C162.918 208.992 163.528 208.786 164.139 208.433C164.719 208.098 165.107 207.72 165.3 207.298C165.479 206.868 165.404 206.439 165.077 206.009L167.221 206.628C167.742 207.221 167.869 207.827 167.601 208.446C167.333 209.065 166.67 209.68 165.613 210.29ZM181.701 231.796L179.355 230.442L178.618 230.275L174.419 227.85C173.675 227.42 172.863 227.218 171.985 227.244C171.121 227.261 170.22 227.541 169.282 228.082C168.642 228.452 168.113 228.878 167.696 229.359C167.279 229.823 167.026 230.279 166.937 230.726L163.251 230.043C163.445 229.398 163.877 228.736 164.547 228.057C165.217 227.377 166.028 226.763 166.981 226.212C168.813 225.155 170.667 224.583 172.543 224.497C174.419 224.411 176.273 224.897 178.104 225.954L184.962 229.913L181.701 231.796ZM178.216 234.014C177.278 234.556 176.318 234.93 175.335 235.136C174.337 235.334 173.384 235.377 172.476 235.265C171.568 235.154 170.771 234.9 170.086 234.505C169.371 234.092 168.917 233.632 168.724 233.125C168.545 232.609 168.686 232.046 169.148 231.435C169.595 230.816 170.429 230.154 171.65 229.449L174.843 227.605L176.876 228.779L174.062 230.404C173.243 230.876 172.811 231.281 172.766 231.616C172.737 231.943 172.923 232.222 173.325 232.454C173.771 232.712 174.3 232.819 174.911 232.776C175.521 232.716 176.132 232.51 176.742 232.157C177.323 231.822 177.71 231.444 177.903 231.023C178.082 230.593 178.008 230.163 177.68 229.733L179.824 230.352C180.346 230.945 180.472 231.551 180.204 232.17C179.936 232.789 179.273 233.404 178.216 234.014ZM193.766 225.139C192.515 225.862 191.153 226.459 189.679 226.932C188.189 227.396 186.827 227.676 185.591 227.77L184.095 225.488C185.241 225.376 186.425 225.148 187.646 224.804C188.867 224.443 189.947 223.992 190.885 223.45C191.599 223.037 192.106 222.668 192.403 222.341C192.701 221.997 192.828 221.692 192.783 221.425C192.738 221.159 192.552 220.931 192.225 220.742C191.808 220.501 191.316 220.407 190.751 220.458C190.17 220.501 189.537 220.634 188.852 220.858C188.152 221.073 187.408 221.331 186.619 221.632C185.829 221.915 185.003 222.186 184.139 222.444C183.291 222.694 182.434 222.878 181.571 222.999C180.707 223.119 179.836 223.123 178.957 223.012C178.094 222.891 177.245 222.59 176.411 222.109C175.518 221.593 174.944 220.987 174.691 220.291C174.438 219.577 174.58 218.816 175.116 218.008C175.652 217.183 176.657 216.344 178.131 215.493C179.114 214.926 180.201 214.436 181.392 214.023C182.568 213.602 183.752 213.314 184.943 213.159L186.574 215.39C185.427 215.571 184.392 215.816 183.469 216.125C182.531 216.426 181.712 216.779 181.012 217.183C180.312 217.587 179.821 217.965 179.538 218.317C179.255 218.67 179.151 218.979 179.225 219.246C179.285 219.504 179.486 219.732 179.828 219.929C180.231 220.162 180.722 220.256 181.303 220.213C181.868 220.162 182.494 220.024 183.179 219.801C183.864 219.577 184.601 219.323 185.39 219.04C186.194 218.747 187.013 218.472 187.847 218.214C188.696 217.948 189.552 217.754 190.416 217.634C191.279 217.514 192.143 217.514 193.006 217.634C193.885 217.746 194.734 218.038 195.553 218.511C196.431 219.018 196.99 219.624 197.228 220.329C197.466 221.034 197.317 221.799 196.781 222.625C196.26 223.441 195.255 224.28 193.766 225.139Z",
    fill: "#123B90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.967 161.418L84.6316 182.533L48.0615 161.419L84.3965 140.303L120.967 161.418Z",
    fill: "url(#paint16_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.967 161.417L120.917 178.738L84.5825 199.853L84.6317 182.533L120.967 161.417Z",
    fill: "url(#paint17_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.69 170.523L85.8326 183.226L85.7915 197.76L107.69 185.034V170.523Z",
    fill: "url(#paint18_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.691 169.941V184.452L119.716 178.045L119.758 163.511L108.691 169.941Z",
    fill: "url(#paint19_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6314 182.533L84.5822 199.853L48.0127 178.74L48.0613 161.419L84.6314 182.533Z",
    fill: "url(#paint20_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1209 181.933L89.1621 184.796V185.47L94.1209 182.607V181.933Z",
    fill: "url(#paint21_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5319 179.963L94.4087 181.767V182.441L97.5319 180.638V179.963Z",
    fill: "url(#paint22_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.688 176.986L97.8198 179.797V180.471L102.688 177.661V176.986Z",
    fill: "url(#paint23_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.976 176.82V177.495L103.878 176.974V176.299L102.976 176.82Z",
    fill: "url(#paint24_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8341 185.747C91.8341 185.735 91.837 185.724 91.8376 185.712L89.1631 187.256V187.93L91.8341 186.388V185.747Z",
    fill: "url(#paint25_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.1191 185.548C92.1197 185.559 92.1209 185.569 92.1209 185.581V186.222L99.3535 182.046V181.372L92.1191 185.548Z",
    fill: "url(#paint26_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6421 181.206V181.88L103.878 179.434V178.76L99.6421 181.206Z",
    fill: "url(#paint27_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.1753 185.667L94.6797 186.531V187.205L96.1753 186.342V185.667Z",
    fill: "url(#paint28_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4634 185.501V186.176L103.878 181.895V181.22L96.4634 185.501Z",
    fill: "url(#paint29_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.3919 186.697L89.1621 189.716V190.391L94.3919 187.371V186.697Z",
    fill: "url(#paint30_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.438 185.667L89.1631 192.176V192.851L100.433 186.345C100.434 186.119 100.437 185.892 100.438 185.667Z",
    fill: "url(#paint31_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.725 185.501C100.723 185.727 100.72 185.954 100.717 186.18L103.878 184.355V183.68L100.725 185.501Z",
    fill: "url(#paint32_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.733 172.127C111.733 172.362 111.567 172.649 111.362 172.768C111.157 172.886 110.991 172.791 110.991 172.556C110.991 172.321 111.157 172.033 111.362 171.915C111.567 171.797 111.733 171.892 111.733 172.127Z",
    fill: "url(#paint33_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.839 170.912C113.839 171.147 113.673 171.434 113.468 171.552C113.263 171.671 113.097 171.576 113.097 171.34C113.097 171.105 113.263 170.818 113.468 170.7C113.673 170.581 113.839 170.676 113.839 170.912Z",
    fill: "url(#paint34_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.944 169.696C115.944 169.931 115.778 170.218 115.573 170.336C115.368 170.454 115.202 170.36 115.202 170.124C115.202 169.889 115.368 169.603 115.573 169.484C115.778 169.366 115.944 169.46 115.944 169.696Z",
    fill: "url(#paint35_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.05 168.48C118.05 168.715 117.884 169.002 117.679 169.12C117.474 169.239 117.308 169.144 117.308 168.908C117.308 168.673 117.474 168.386 117.679 168.268C117.884 168.15 118.05 168.245 118.05 168.48Z",
    fill: "url(#paint36_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.733 174.418C111.733 174.653 111.567 174.94 111.362 175.058C111.157 175.177 110.991 175.082 110.991 174.846C110.991 174.611 111.157 174.324 111.362 174.206C111.567 174.088 111.733 174.183 111.733 174.418Z",
    fill: "url(#paint37_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.839 173.202C113.839 173.437 113.673 173.724 113.468 173.842C113.263 173.96 113.097 173.866 113.097 173.63C113.097 173.395 113.263 173.108 113.468 172.99C113.673 172.872 113.839 172.967 113.839 173.202Z",
    fill: "url(#paint38_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.944 171.986C115.944 172.221 115.778 172.508 115.573 172.626C115.368 172.745 115.202 172.65 115.202 172.415C115.202 172.179 115.368 171.893 115.573 171.774C115.778 171.656 115.944 171.751 115.944 171.986Z",
    fill: "url(#paint39_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.05 170.77C118.05 171.005 117.884 171.292 117.679 171.41C117.474 171.529 117.308 171.434 117.308 171.199C117.308 170.963 117.474 170.676 117.679 170.558C117.884 170.44 118.05 170.535 118.05 170.77Z",
    fill: "url(#paint40_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.733 176.708C111.733 176.943 111.567 177.23 111.362 177.348C111.157 177.467 110.991 177.372 110.991 177.137C110.991 176.901 111.157 176.614 111.362 176.496C111.567 176.378 111.733 176.473 111.733 176.708Z",
    fill: "url(#paint41_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.839 175.492C113.839 175.727 113.673 176.014 113.468 176.132C113.263 176.251 113.097 176.156 113.097 175.92C113.097 175.685 113.263 175.398 113.468 175.28C113.673 175.162 113.839 175.257 113.839 175.492Z",
    fill: "url(#paint42_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.944 174.276C115.944 174.512 115.778 174.799 115.573 174.917C115.368 175.036 115.202 174.941 115.202 174.705C115.202 174.47 115.368 174.183 115.573 174.065C115.778 173.946 115.944 174.041 115.944 174.276Z",
    fill: "url(#paint43_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.05 173.061C118.05 173.296 117.884 173.583 117.679 173.701C117.474 173.819 117.308 173.725 117.308 173.489C117.308 173.254 117.474 172.967 117.679 172.849C117.884 172.731 118.05 172.825 118.05 173.061Z",
    fill: "url(#paint44_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.733 178.998C111.733 179.233 111.567 179.52 111.362 179.639C111.157 179.757 110.991 179.663 110.991 179.427C110.991 179.192 111.157 178.905 111.362 178.786C111.567 178.668 111.733 178.763 111.733 178.998Z",
    fill: "url(#paint45_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.839 177.783C113.839 178.018 113.673 178.305 113.468 178.423C113.263 178.541 113.097 178.447 113.097 178.211C113.097 177.976 113.263 177.689 113.468 177.571C113.673 177.453 113.839 177.547 113.839 177.783Z",
    fill: "url(#paint46_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.944 176.567C115.944 176.802 115.778 177.089 115.573 177.207C115.368 177.326 115.202 177.231 115.202 176.995C115.202 176.76 115.368 176.473 115.573 176.355C115.778 176.236 115.944 176.331 115.944 176.567Z",
    fill: "url(#paint47_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.05 175.351C118.05 175.586 117.884 175.873 117.679 175.991C117.474 176.109 117.308 176.015 117.308 175.779C117.308 175.544 117.474 175.257 117.679 175.139C117.884 175.021 118.05 175.116 118.05 175.351Z",
    fill: "url(#paint48_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.967 138.097L84.6316 159.212L48.0615 138.099L84.3965 116.983L120.967 138.097Z",
    fill: "url(#paint49_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.967 138.097L120.917 155.417L84.5825 176.533L84.6317 159.212L120.967 138.097Z",
    fill: "url(#paint50_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.69 147.203L85.8326 159.905L85.7915 174.439L107.69 161.713V147.203Z",
    fill: "url(#paint51_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.691 146.621V161.131L119.716 154.724L119.758 140.19L108.691 146.621Z",
    fill: "url(#paint52_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6314 159.212L84.5822 176.533L48.0127 155.419L48.0613 138.099L84.6314 159.212Z",
    fill: "url(#paint53_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1209 158.612L89.1621 161.475V162.149L94.1209 159.287V158.612Z",
    fill: "url(#paint54_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5319 156.642L94.4087 158.446V159.121L97.5319 157.317V156.642Z",
    fill: "url(#paint55_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.688 153.666L97.8198 156.476V157.151L102.688 154.34V153.666Z",
    fill: "url(#paint56_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.976 153.499V154.174L103.878 153.653V152.978L102.976 153.499Z",
    fill: "url(#paint57_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8341 162.426C91.8341 162.414 91.837 162.403 91.8376 162.391L89.1631 163.935V164.61L91.8341 163.067V162.426Z",
    fill: "url(#paint58_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.1191 162.228C92.1197 162.238 92.1209 162.248 92.1209 162.26V162.902L99.3535 158.726V158.051L92.1191 162.228Z",
    fill: "url(#paint59_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6421 157.885V158.56L103.878 156.113V155.439L99.6421 157.885Z",
    fill: "url(#paint60_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.1753 162.346L94.6797 163.21V163.884L96.1753 163.021V162.346Z",
    fill: "url(#paint61_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4634 162.18V162.855L103.878 158.574V157.899L96.4634 162.18Z",
    fill: "url(#paint62_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.3919 163.376L89.1621 166.395V167.07L94.3919 164.05V163.376Z",
    fill: "url(#paint63_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.438 162.346L89.1631 168.856V169.53L100.433 163.024C100.434 162.798 100.437 162.572 100.438 162.346Z",
    fill: "url(#paint64_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.725 162.18C100.723 162.406 100.72 162.633 100.717 162.859L103.878 161.034V160.36L100.725 162.18Z",
    fill: "url(#paint65_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.733 148.806C111.733 149.041 111.567 149.329 111.362 149.447C111.157 149.565 110.991 149.471 110.991 149.235C110.991 149 111.157 148.713 111.362 148.594C111.567 148.476 111.733 148.571 111.733 148.806Z",
    fill: "url(#paint66_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.839 147.591C113.839 147.826 113.673 148.113 113.468 148.232C113.263 148.35 113.097 148.255 113.097 148.02C113.097 147.784 113.263 147.497 113.468 147.379C113.673 147.261 113.839 147.356 113.839 147.591Z",
    fill: "url(#paint67_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.944 146.375C115.944 146.61 115.778 146.897 115.573 147.016C115.368 147.134 115.202 147.039 115.202 146.804C115.202 146.569 115.368 146.282 115.573 146.163C115.778 146.045 115.944 146.139 115.944 146.375Z",
    fill: "url(#paint68_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.05 145.159C118.05 145.394 117.884 145.681 117.679 145.8C117.474 145.918 117.308 145.823 117.308 145.588C117.308 145.352 117.474 145.065 117.679 144.947C117.884 144.829 118.05 144.924 118.05 145.159Z",
    fill: "url(#paint69_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.733 151.097C111.733 151.332 111.567 151.619 111.362 151.738C111.157 151.856 110.991 151.761 110.991 151.526C110.991 151.291 111.157 151.003 111.362 150.885C111.567 150.767 111.733 150.862 111.733 151.097Z",
    fill: "url(#paint70_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.839 149.881C113.839 150.116 113.673 150.403 113.468 150.522C113.263 150.64 113.097 150.545 113.097 150.31C113.097 150.075 113.263 149.787 113.468 149.669C113.673 149.551 113.839 149.646 113.839 149.881Z",
    fill: "url(#paint71_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.944 148.665C115.944 148.9 115.778 149.188 115.573 149.306C115.368 149.424 115.202 149.329 115.202 149.094C115.202 148.859 115.368 148.572 115.573 148.453C115.778 148.335 115.944 148.43 115.944 148.665Z",
    fill: "url(#paint72_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.05 147.449C118.05 147.684 117.884 147.972 117.679 148.09C117.474 148.208 117.308 148.113 117.308 147.878C117.308 147.643 117.474 147.355 117.679 147.237C117.884 147.119 118.05 147.214 118.05 147.449Z",
    fill: "url(#paint73_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.733 153.387C111.733 153.622 111.567 153.91 111.362 154.028C111.157 154.146 110.991 154.051 110.991 153.816C110.991 153.581 111.157 153.293 111.362 153.175C111.567 153.057 111.733 153.152 111.733 153.387Z",
    fill: "url(#paint74_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.839 152.171C113.839 152.406 113.673 152.693 113.468 152.812C113.263 152.93 113.097 152.835 113.097 152.6C113.097 152.365 113.263 152.077 113.468 151.959C113.673 151.841 113.839 151.936 113.839 152.171Z",
    fill: "url(#paint75_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.944 150.956C115.944 151.191 115.778 151.478 115.573 151.596C115.368 151.715 115.202 151.62 115.202 151.384C115.202 151.149 115.368 150.863 115.573 150.744C115.778 150.625 115.944 150.72 115.944 150.956Z",
    fill: "url(#paint76_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.05 149.74C118.05 149.975 117.884 150.262 117.679 150.38C117.474 150.498 117.308 150.404 117.308 150.168C117.308 149.933 117.474 149.646 117.679 149.528C117.884 149.41 118.05 149.504 118.05 149.74Z",
    fill: "url(#paint77_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.733 155.678C111.733 155.913 111.567 156.199 111.362 156.318C111.157 156.436 110.991 156.342 110.991 156.106C110.991 155.871 111.157 155.584 111.362 155.466C111.567 155.348 111.733 155.442 111.733 155.678Z",
    fill: "url(#paint78_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.839 154.462C113.839 154.697 113.673 154.984 113.468 155.102C113.263 155.22 113.097 155.126 113.097 154.89C113.097 154.655 113.263 154.368 113.468 154.25C113.673 154.132 113.839 154.226 113.839 154.462Z",
    fill: "url(#paint79_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.944 153.246C115.944 153.481 115.778 153.768 115.573 153.886C115.368 154.005 115.202 153.91 115.202 153.674C115.202 153.439 115.368 153.152 115.573 153.034C115.778 152.916 115.944 153.01 115.944 153.246Z",
    fill: "url(#paint80_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.05 152.03C118.05 152.265 117.884 152.552 117.679 152.67C117.474 152.788 117.308 152.694 117.308 152.458C117.308 152.223 117.474 151.936 117.679 151.818C117.884 151.7 118.05 151.795 118.05 152.03Z",
    fill: "url(#paint81_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.967 116.114L84.6316 137.229L48.0615 116.116L84.3965 95L120.967 116.114Z",
    fill: "url(#paint82_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.967 116.114L120.917 133.435L84.5825 154.55L84.6317 137.23L120.967 116.114Z",
    fill: "url(#paint83_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.69 125.22L85.8326 137.923L85.7915 152.457L107.69 139.73V125.22Z",
    fill: "url(#paint84_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.691 124.638V139.149L119.716 132.742L119.758 118.208L108.691 124.638Z",
    fill: "url(#paint85_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6314 137.23L84.5822 154.55L48.0127 133.436L48.0613 116.116L84.6314 137.23Z",
    fill: "url(#paint86_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1209 136.629L89.1621 139.492V140.167L94.1209 137.304V136.629Z",
    fill: "url(#paint87_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5319 134.66L94.4087 136.463V137.138L97.5319 135.334V134.66Z",
    fill: "url(#paint88_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.688 131.683L97.8198 134.493V135.168L102.688 132.357V131.683Z",
    fill: "url(#paint89_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.976 131.517V132.191L103.878 131.67V130.996L102.976 131.517Z",
    fill: "url(#paint90_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8341 140.444C91.8341 140.431 91.837 140.42 91.8376 140.408L89.1631 141.952V142.627L91.8341 141.085V140.444Z",
    fill: "url(#paint91_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.1191 140.245C92.1197 140.255 92.1209 140.266 92.1209 140.277V140.919L99.3535 136.743V136.068L92.1191 140.245Z",
    fill: "url(#paint92_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6421 135.902V136.577L103.878 134.131V133.457L99.6421 135.902Z",
    fill: "url(#paint93_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.1753 140.364L94.6797 141.227V141.901L96.1753 141.038V140.364Z",
    fill: "url(#paint94_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4634 140.197V140.872L103.878 136.591V135.917L96.4634 140.197Z",
    fill: "url(#paint95_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.3919 141.393L89.1621 144.413V145.087L94.3919 142.068V141.393Z",
    fill: "url(#paint96_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.438 140.363L89.1631 146.873V147.548L100.433 141.041C100.434 140.815 100.437 140.589 100.438 140.363Z",
    fill: "url(#paint97_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.725 140.197C100.723 140.423 100.72 140.65 100.717 140.877L103.878 139.052V138.377L100.725 140.197Z",
    fill: "url(#paint98_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.733 126.824C111.733 127.059 111.567 127.346 111.362 127.464C111.157 127.582 110.991 127.488 110.991 127.252C110.991 127.017 111.157 126.73 111.362 126.612C111.567 126.494 111.733 126.589 111.733 126.824Z",
    fill: "url(#paint99_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.839 125.609C113.839 125.844 113.673 126.131 113.468 126.249C113.263 126.367 113.097 126.273 113.097 126.037C113.097 125.801 113.263 125.515 113.468 125.397C113.673 125.278 113.839 125.373 113.839 125.609Z",
    fill: "url(#paint100_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.944 124.392C115.944 124.628 115.778 124.915 115.573 125.033C115.368 125.151 115.202 125.057 115.202 124.821C115.202 124.586 115.368 124.299 115.573 124.181C115.778 124.062 115.944 124.157 115.944 124.392Z",
    fill: "url(#paint101_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.05 123.177C118.05 123.412 117.884 123.699 117.679 123.817C117.474 123.935 117.308 123.841 117.308 123.605C117.308 123.369 117.474 123.083 117.679 122.965C117.884 122.846 118.05 122.941 118.05 123.177Z",
    fill: "url(#paint102_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.733 129.115C111.733 129.35 111.567 129.637 111.362 129.755C111.157 129.874 110.991 129.779 110.991 129.543C110.991 129.308 111.157 129.021 111.362 128.903C111.567 128.784 111.733 128.879 111.733 129.115Z",
    fill: "url(#paint103_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.839 127.898C113.839 128.134 113.673 128.421 113.468 128.539C113.263 128.657 113.097 128.563 113.097 128.327C113.097 128.092 113.263 127.805 113.468 127.687C113.673 127.568 113.839 127.663 113.839 127.898Z",
    fill: "url(#paint104_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.944 126.683C115.944 126.918 115.778 127.205 115.573 127.323C115.368 127.441 115.202 127.347 115.202 127.111C115.202 126.876 115.368 126.589 115.573 126.471C115.778 126.353 115.944 126.448 115.944 126.683Z",
    fill: "url(#paint105_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.05 125.467C118.05 125.702 117.884 125.989 117.679 126.107C117.474 126.225 117.308 126.131 117.308 125.895C117.308 125.66 117.474 125.373 117.679 125.255C117.884 125.137 118.05 125.231 118.05 125.467Z",
    fill: "url(#paint106_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.733 131.405C111.733 131.64 111.567 131.927 111.362 132.045C111.157 132.164 110.991 132.069 110.991 131.833C110.991 131.598 111.157 131.311 111.362 131.193C111.567 131.075 111.733 131.169 111.733 131.405Z",
    fill: "url(#paint107_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.839 130.188C113.839 130.424 113.673 130.711 113.468 130.829C113.263 130.948 113.097 130.853 113.097 130.617C113.097 130.382 113.263 130.095 113.468 129.977C113.673 129.858 113.839 129.953 113.839 130.188Z",
    fill: "url(#paint108_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.944 128.973C115.944 129.208 115.778 129.495 115.573 129.613C115.368 129.732 115.202 129.637 115.202 129.402C115.202 129.166 115.368 128.88 115.573 128.761C115.778 128.642 115.944 128.737 115.944 128.973Z",
    fill: "url(#paint109_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.05 127.757C118.05 127.992 117.884 128.279 117.679 128.398C117.474 128.516 117.308 128.421 117.308 128.186C117.308 127.951 117.474 127.663 117.679 127.545C117.884 127.427 118.05 127.522 118.05 127.757Z",
    fill: "url(#paint110_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.733 133.695C111.733 133.93 111.567 134.217 111.362 134.335C111.157 134.453 110.991 134.359 110.991 134.123C110.991 133.888 111.157 133.601 111.362 133.483C111.567 133.365 111.733 133.459 111.733 133.695Z",
    fill: "url(#paint111_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.839 132.479C113.839 132.714 113.673 133.001 113.468 133.12C113.263 133.238 113.097 133.143 113.097 132.908C113.097 132.673 113.263 132.385 113.468 132.267C113.673 132.149 113.839 132.243 113.839 132.479Z",
    fill: "url(#paint112_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.944 131.263C115.944 131.498 115.778 131.785 115.573 131.903C115.368 132.022 115.202 131.927 115.202 131.692C115.202 131.456 115.368 131.169 115.573 131.051C115.778 130.933 115.944 131.027 115.944 131.263Z",
    fill: "url(#paint113_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.05 130.047C118.05 130.282 117.884 130.569 117.679 130.688C117.474 130.806 117.308 130.711 117.308 130.476C117.308 130.241 117.474 129.953 117.679 129.835C117.884 129.717 118.05 129.812 118.05 130.047Z",
    fill: "url(#paint114_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.979 257.477L116.196 260.343L116.18 265.368L118.963 262.502L118.979 257.477Z",
    fill: "url(#paint115_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7846 267.887C99.7872 267.864 99.7909 267.841 99.7942 267.818C99.7984 267.792 99.8026 267.765 99.808 267.739C99.813 267.715 99.8185 267.692 99.8243 267.668C99.8306 267.643 99.8377 267.617 99.8452 267.591C99.8523 267.568 99.8598 267.545 99.8678 267.521C99.8765 267.496 99.8857 267.47 99.8957 267.444C99.9049 267.421 99.9145 267.399 99.9246 267.376C99.9363 267.349 99.9488 267.323 99.9622 267.296C99.973 267.274 99.9847 267.251 99.9968 267.229C100.011 267.202 100.026 267.176 100.042 267.149C100.055 267.128 100.068 267.107 100.082 267.085C100.103 267.054 100.124 267.023 100.146 266.992C100.16 266.973 100.173 266.954 100.187 266.935C100.214 266.901 100.242 266.866 100.27 266.833C100.283 266.818 100.295 266.803 100.308 266.788C100.355 266.734 100.406 266.681 100.46 266.628C100.474 266.614 100.489 266.601 100.503 266.588C100.546 266.547 100.59 266.508 100.636 266.468C100.658 266.45 100.679 266.432 100.701 266.414C100.728 266.392 100.756 266.37 100.785 266.348C100.812 266.328 100.839 266.307 100.866 266.287C100.896 266.265 100.927 266.244 100.958 266.223C100.986 266.203 101.016 266.183 101.046 266.163C101.078 266.142 101.111 266.121 101.145 266.1C101.176 266.081 101.207 266.062 101.239 266.043C101.273 266.022 101.309 266.002 101.345 265.982C101.39 265.956 101.435 265.931 101.481 265.907C101.609 265.84 101.742 265.778 101.878 265.719C101.913 265.704 101.95 265.688 101.985 265.673C102.108 265.622 102.234 265.573 102.362 265.528C102.378 265.522 102.395 265.516 102.412 265.51C102.549 265.463 102.691 265.42 102.834 265.38C102.933 265.351 103.035 265.327 103.136 265.302C103.213 265.283 103.289 265.263 103.367 265.246C103.474 265.222 103.583 265.203 103.692 265.183C103.771 265.169 103.849 265.152 103.929 265.14C103.962 265.135 103.996 265.13 104.028 265.126C104.163 265.106 104.299 265.088 104.436 265.074C104.475 265.069 104.515 265.065 104.554 265.061C104.713 265.045 104.872 265.033 105.032 265.025C105.061 265.023 105.091 265.022 105.12 265.021C105.228 265.016 105.335 265.014 105.443 265.013C105.55 265.011 105.658 265.01 105.765 265.012C105.855 265.013 105.944 265.015 106.034 265.018C106.133 265.022 106.233 265.027 106.332 265.033C106.423 265.038 106.513 265.045 106.603 265.053C106.702 265.062 106.8 265.071 106.897 265.083C106.985 265.093 107.073 265.104 107.16 265.116C107.265 265.131 107.368 265.147 107.471 265.165C107.553 265.179 107.635 265.194 107.715 265.209C107.838 265.234 107.96 265.261 108.08 265.29C108.158 265.308 108.237 265.326 108.314 265.346C108.356 265.357 108.397 265.369 108.438 265.381C108.559 265.415 108.678 265.452 108.795 265.491C108.829 265.502 108.863 265.513 108.897 265.525C109.003 265.562 109.106 265.603 109.208 265.644C109.259 265.664 109.311 265.683 109.361 265.704C109.509 265.767 109.653 265.835 109.792 265.907C110.951 266.51 111.529 267.301 111.527 268.091L111.543 263.065C111.545 262.275 110.967 261.484 109.808 260.881C109.669 260.809 109.525 260.742 109.377 260.679C109.327 260.658 109.275 260.639 109.224 260.619C109.137 260.584 109.051 260.547 108.96 260.515C108.945 260.51 108.928 260.505 108.913 260.5C108.879 260.488 108.844 260.477 108.81 260.466C108.693 260.427 108.574 260.39 108.454 260.356C108.412 260.344 108.371 260.332 108.33 260.321C108.302 260.314 108.275 260.306 108.247 260.298C108.197 260.285 108.146 260.277 108.096 260.265C107.975 260.236 107.854 260.209 107.731 260.184C107.698 260.178 107.666 260.169 107.633 260.163C107.585 260.154 107.536 260.148 107.487 260.14C107.384 260.122 107.28 260.106 107.176 260.091C107.134 260.085 107.093 260.077 107.051 260.072C107.005 260.066 106.959 260.063 106.913 260.058C106.815 260.046 106.717 260.037 106.619 260.028C106.572 260.024 106.526 260.017 106.479 260.014C106.435 260.011 106.391 260.01 106.348 260.008C106.248 260.001 106.149 259.997 106.05 259.993C106 259.991 105.95 259.987 105.9 259.986C105.861 259.985 105.821 259.987 105.781 259.987C105.673 259.985 105.566 259.986 105.459 259.988C105.405 259.988 105.352 259.987 105.299 259.988C105.244 259.99 105.19 259.993 105.136 259.996C105.106 259.997 105.077 259.999 105.047 260C104.913 260.007 104.78 260.016 104.647 260.028C104.621 260.03 104.596 260.034 104.57 260.036C104.53 260.04 104.491 260.045 104.451 260.049C104.315 260.064 104.179 260.081 104.045 260.101C104.011 260.106 103.978 260.11 103.945 260.115C103.929 260.118 103.913 260.119 103.897 260.122C103.833 260.132 103.772 260.147 103.708 260.159C103.599 260.178 103.49 260.198 103.383 260.221C103.305 260.238 103.229 260.259 103.152 260.277C103.051 260.302 102.949 260.327 102.85 260.355C102.828 260.361 102.806 260.366 102.784 260.372C102.663 260.407 102.544 260.445 102.427 260.486C102.411 260.492 102.394 260.498 102.378 260.504C102.249 260.549 102.124 260.598 102.001 260.649C101.965 260.664 101.929 260.679 101.894 260.695C101.758 260.754 101.625 260.816 101.497 260.883C101.473 260.895 101.449 260.908 101.425 260.921C101.403 260.933 101.383 260.945 101.361 260.958C101.325 260.978 101.289 260.998 101.254 261.019C101.222 261.038 101.191 261.057 101.161 261.076C101.127 261.097 101.094 261.117 101.062 261.139C101.031 261.158 101.003 261.178 100.974 261.198C100.943 261.22 100.912 261.241 100.882 261.263C100.854 261.283 100.827 261.304 100.801 261.324C100.772 261.346 100.744 261.368 100.716 261.391C100.705 261.4 100.692 261.409 100.681 261.418C100.671 261.427 100.662 261.436 100.652 261.444C100.605 261.484 100.561 261.523 100.519 261.564C100.504 261.577 100.489 261.59 100.475 261.604C100.422 261.657 100.371 261.71 100.323 261.765C100.321 261.767 100.318 261.769 100.317 261.771C100.306 261.784 100.297 261.797 100.286 261.809C100.257 261.843 100.229 261.877 100.203 261.911C100.189 261.93 100.176 261.949 100.162 261.968C100.14 261.999 100.118 262.03 100.097 262.062C100.092 262.071 100.085 262.079 100.08 262.088C100.072 262.1 100.066 262.113 100.058 262.126C100.042 262.152 100.026 262.179 100.012 262.205C100 262.228 99.9889 262.25 99.9776 262.272C99.9642 262.299 99.9517 262.326 99.94 262.352C99.9346 262.365 99.9283 262.376 99.9233 262.388C99.9187 262.399 99.9158 262.41 99.9112 262.421C99.9012 262.446 99.892 262.472 99.8828 262.497C99.8749 262.521 99.8669 262.544 99.8602 262.567C99.8523 262.593 99.8456 262.619 99.8394 262.644C99.836 262.658 99.831 262.672 99.8281 262.686C99.826 262.696 99.8252 262.705 99.8231 262.714C99.8176 262.741 99.8135 262.768 99.8093 262.794C99.8059 262.817 99.8022 262.84 99.7997 262.863C99.7968 262.89 99.7951 262.917 99.7934 262.943C99.7926 262.959 99.7901 262.975 99.7897 262.99C99.7892 263.005 99.7888 263.021 99.7888 263.037L99.7729 268.062C99.7729 268.031 99.7755 268 99.7775 267.969C99.78 267.941 99.7817 267.914 99.7846 267.887Z",
    fill: "url(#paint116_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.61 266.296L115.457 266.462C115.358 266.54 115.254 266.617 115.147 266.692C115.112 266.717 115.076 266.741 115.04 266.765C114.967 266.816 114.892 266.867 114.815 266.916C114.771 266.945 114.724 266.973 114.679 267.002C114.607 267.047 114.535 267.091 114.46 267.135C114.41 267.164 114.358 267.193 114.307 267.222C114.208 267.278 114.109 267.334 114.006 267.388C113.73 267.532 113.444 267.668 113.149 267.794C112.854 267.92 112.549 268.038 112.237 268.148L111.938 271.36L108.298 271.869L104.925 269.169C104.661 269.16 104.398 269.145 104.136 269.126C104.063 269.121 103.99 269.116 103.917 269.11C103.821 269.102 103.724 269.094 103.628 269.085C103.535 269.076 103.443 269.067 103.351 269.058C103.255 269.048 103.159 269.036 103.063 269.025C102.973 269.014 102.882 269.003 102.792 268.991C102.69 268.978 102.587 268.962 102.485 268.947C102.398 268.935 102.311 268.922 102.225 268.908C102.122 268.891 102.021 268.874 101.919 268.856C101.836 268.841 101.752 268.826 101.669 268.81C101.538 268.786 101.408 268.759 101.278 268.731C101.214 268.717 101.15 268.705 101.086 268.691C100.903 268.65 100.721 268.606 100.54 268.561C100.531 268.558 100.522 268.556 100.513 268.554L95.126 269.991L95.1394 265.759C94.449 265.033 94.0497 264.249 93.9448 263.458L88.7605 261.706L88.7446 266.732L93.929 268.483C93.9803 268.871 94.1031 269.256 94.2953 269.633L92.3568 268.625L92.3409 273.65L95.0154 275.042L100.497 273.58C100.499 273.58 100.5 273.581 100.501 273.581C100.509 273.583 100.517 273.585 100.525 273.587C100.705 273.633 100.887 273.676 101.071 273.717C101.134 273.731 101.199 273.744 101.263 273.757C101.393 273.785 101.523 273.812 101.654 273.837C101.679 273.841 101.703 273.847 101.728 273.852C101.786 273.863 101.845 273.871 101.903 273.882C102.005 273.9 102.107 273.917 102.209 273.934C102.296 273.948 102.383 273.961 102.469 273.974C102.572 273.989 102.674 274.004 102.777 274.017C102.813 274.022 102.849 274.028 102.886 274.033C102.94 274.039 102.994 274.045 103.048 274.051C103.144 274.062 103.24 274.074 103.336 274.084C103.428 274.094 103.52 274.103 103.613 274.111C103.709 274.12 103.805 274.129 103.902 274.136C103.943 274.14 103.983 274.144 104.024 274.147C104.056 274.149 104.088 274.15 104.121 274.152C104.383 274.171 104.646 274.186 104.91 274.195L108.283 276.895L111.922 276.386L112.222 273.173C112.847 272.955 113.44 272.702 113.991 272.414C114.048 272.384 114.104 272.354 114.16 272.324C114.205 272.299 114.248 272.274 114.292 272.248C114.343 272.219 114.396 272.19 114.446 272.16C114.52 272.117 114.592 272.072 114.664 272.028C114.71 271.999 114.756 271.971 114.801 271.942C114.878 271.892 114.952 271.842 115.025 271.792C115.061 271.767 115.098 271.743 115.133 271.718C115.24 271.642 115.343 271.565 115.443 271.488L121.596 271.321L122.559 269.42L122.575 264.395L121.61 266.296Z",
    fill: "url(#paint117_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.006 267.388C113.454 267.677 112.861 267.93 112.237 268.148L111.937 271.36L108.297 271.87L104.924 269.17C103.407 269.118 101.906 268.913 100.512 268.555L95.0296 270.016L92.3551 268.625L95.1382 265.759C94.4478 265.033 94.0484 264.25 93.9436 263.458L88.7593 261.706L89.7229 259.806L95.8771 259.639C96.2952 259.312 96.7768 259.002 97.3281 258.714C97.8795 258.425 98.4722 258.172 99.097 257.953L99.3961 254.741L103.035 254.232L106.409 256.932C107.926 256.984 109.428 257.189 110.824 257.547L116.304 256.086L118.979 257.477L116.196 260.343C116.887 261.069 117.284 261.852 117.39 262.643L122.574 264.395L121.61 266.296L115.457 266.462C115.039 266.79 114.557 267.1 114.006 267.388ZM101.524 265.219C103.826 266.417 107.548 266.417 109.835 265.219C112.123 264.022 112.11 262.08 109.808 260.882C107.506 259.684 103.784 259.684 101.497 260.882C99.2098 262.08 99.2219 264.021 101.524 265.219Z",
    fill: "url(#paint118_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.664 240.906L100.806 245.315L100.784 253.047L104.642 248.637L104.664 240.906Z",
    fill: "url(#paint119_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0553 256.924C78.0587 256.888 78.064 256.852 78.0686 256.817C78.0744 256.777 78.0802 256.735 78.0877 256.695C78.0946 256.659 78.1022 256.623 78.1103 256.587C78.119 256.547 78.1288 256.507 78.1392 256.468C78.1491 256.432 78.1595 256.396 78.1705 256.36C78.1827 256.321 78.1954 256.281 78.2093 256.242C78.222 256.207 78.2354 256.172 78.2492 256.137C78.2655 256.096 78.2828 256.054 78.3014 256.013C78.3164 255.979 78.3326 255.944 78.3494 255.91C78.3697 255.869 78.3905 255.829 78.4125 255.788C78.4305 255.755 78.4484 255.722 78.4675 255.69C78.4959 255.641 78.526 255.594 78.5567 255.546C78.5758 255.517 78.5938 255.487 78.6135 255.458C78.6499 255.405 78.6887 255.353 78.7287 255.301C78.746 255.278 78.7623 255.255 78.7802 255.232C78.8462 255.149 78.9169 255.067 78.9916 254.986C79.0107 254.965 79.0315 254.944 79.0512 254.924C79.1103 254.862 79.1716 254.801 79.2359 254.74C79.2654 254.712 79.295 254.685 79.3251 254.657C79.3633 254.623 79.4021 254.589 79.442 254.555C79.4791 254.524 79.5167 254.492 79.5549 254.461C79.5961 254.428 79.6383 254.395 79.6812 254.362C79.7211 254.331 79.7617 254.301 79.8039 254.27C79.8485 254.237 79.8943 254.206 79.9406 254.174C79.9834 254.144 80.0269 254.115 80.0709 254.085C80.1189 254.053 80.1687 254.023 80.2185 253.991C80.2805 253.953 80.3424 253.914 80.4073 253.876C80.5839 253.774 80.7686 253.679 80.9568 253.587C81.006 253.564 81.0564 253.54 81.1062 253.517C81.2764 253.438 81.4501 253.363 81.6279 253.294C81.651 253.284 81.6736 253.275 81.6973 253.265C81.8878 253.193 82.0841 253.127 82.2822 253.065C82.4194 253.022 82.5607 252.984 82.7014 252.945C82.8079 252.916 82.9133 252.885 83.0216 252.859C83.1698 252.823 83.3209 252.793 83.4715 252.763C83.5815 252.741 83.6898 252.715 83.8009 252.696C83.8467 252.688 83.893 252.682 83.9382 252.674C84.1252 252.643 84.3134 252.617 84.5027 252.594C84.5577 252.588 84.6121 252.58 84.6672 252.575C84.8866 252.551 85.1072 252.532 85.329 252.519C85.3701 252.517 85.4106 252.515 85.4517 252.513C85.6005 252.505 85.7499 252.503 85.8987 252.5C86.0476 252.498 86.1969 252.496 86.3458 252.499C86.4702 252.5 86.5942 252.504 86.7181 252.509C86.8564 252.514 86.9943 252.522 87.1321 252.531C87.2577 252.54 87.3828 252.55 87.5079 252.562C87.6445 252.576 87.78 252.591 87.9155 252.608C88.0371 252.624 88.1587 252.641 88.2797 252.66C88.4244 252.682 88.568 252.708 88.7111 252.735C88.8246 252.756 88.9375 252.779 89.0492 252.803C89.22 252.841 89.3879 252.883 89.5553 252.927C89.6636 252.956 89.773 252.983 89.879 253.014C89.9369 253.031 89.9936 253.049 90.0509 253.067C90.2183 253.12 90.3833 253.176 90.5454 253.236C90.5929 253.254 90.641 253.271 90.6873 253.288C90.8349 253.346 90.9768 253.409 91.1192 253.472C91.1893 253.503 91.2617 253.532 91.3306 253.564C91.5361 253.661 91.7359 253.765 91.9281 253.876C93.5343 254.804 94.3363 256.021 94.3328 257.236L94.3548 249.504C94.3583 248.289 93.5563 247.071 91.9501 246.144C91.7579 246.033 91.5581 245.93 91.3526 245.832C91.2837 245.799 91.2113 245.771 91.1412 245.74C91.0196 245.686 90.9004 245.63 90.7747 245.58C90.7533 245.572 90.7307 245.565 90.7093 245.557C90.6624 245.539 90.6143 245.522 90.5674 245.505C90.4053 245.444 90.2403 245.388 90.0729 245.336C90.0156 245.318 89.9589 245.299 89.901 245.282C89.8622 245.271 89.8251 245.258 89.7857 245.246C89.7174 245.227 89.6462 245.213 89.5773 245.195C89.41 245.151 89.242 245.109 89.0706 245.072C89.0249 245.062 88.9815 245.048 88.9357 245.039C88.8691 245.025 88.8002 245.016 88.7331 245.003C88.59 244.976 88.4464 244.951 88.3011 244.928C88.2432 244.919 88.1865 244.906 88.128 244.898C88.0649 244.889 88.0006 244.885 87.9369 244.876C87.8014 244.859 87.6659 244.844 87.5293 244.831C87.4644 244.824 87.4007 244.814 87.3353 244.809C87.2751 244.804 87.2137 244.803 87.1535 244.799C87.0157 244.79 86.8779 244.783 86.7401 244.777C86.6712 244.774 86.6023 244.768 86.5334 244.766C86.4783 244.765 86.4228 244.768 86.3678 244.767C86.2184 244.765 86.0696 244.766 85.9207 244.769C85.8466 244.77 85.7725 244.767 85.699 244.77C85.6237 244.772 85.549 244.777 85.4737 244.781C85.4326 244.784 85.3921 244.785 85.351 244.788C85.1651 244.799 84.9798 244.812 84.7951 244.831C84.7598 244.834 84.7245 244.839 84.6892 244.843C84.6342 244.849 84.5797 244.856 84.5247 244.863C84.3354 244.886 84.1472 244.912 83.9607 244.943C83.9144 244.951 83.8681 244.957 83.8224 244.965C83.8004 244.969 83.7784 244.971 83.7564 244.975C83.6678 244.991 83.5826 245.014 83.4946 245.032C83.3435 245.062 83.1924 245.092 83.0436 245.128C82.9353 245.154 82.8299 245.186 82.7234 245.215C82.5827 245.253 82.442 245.291 82.3042 245.334C82.2746 245.344 82.2434 245.351 82.2138 245.36C82.0459 245.414 81.8809 245.473 81.7188 245.535C81.6956 245.544 81.673 245.554 81.6499 245.563C81.4715 245.633 81.2984 245.707 81.1282 245.786C81.0778 245.809 81.028 245.832 80.9788 245.857C80.7906 245.948 80.6059 246.043 80.4293 246.146C80.3957 246.165 80.3627 246.184 80.3297 246.205C80.299 246.223 80.2706 246.242 80.2405 246.261C80.1907 246.292 80.1409 246.323 80.0929 246.355C80.0483 246.384 80.0054 246.414 79.9626 246.443C79.9163 246.475 79.8699 246.507 79.8254 246.54C79.7837 246.57 79.7437 246.601 79.7038 246.631C79.6609 246.664 79.6181 246.697 79.5764 246.731C79.5382 246.762 79.5005 246.794 79.464 246.825C79.4241 246.859 79.3847 246.893 79.3465 246.927C79.3309 246.942 79.3135 246.955 79.2979 246.97C79.2834 246.983 79.2712 246.997 79.2573 247.01C79.1931 247.07 79.1317 247.132 79.0726 247.194C79.0529 247.215 79.0321 247.235 79.013 247.256C78.9383 247.337 78.8676 247.419 78.8016 247.503C78.7987 247.506 78.7953 247.51 78.7929 247.513C78.7779 247.532 78.7652 247.552 78.7507 247.571C78.7107 247.623 78.6719 247.676 78.6355 247.729C78.6158 247.758 78.5978 247.787 78.5787 247.816C78.5474 247.864 78.5173 247.912 78.489 247.96C78.4814 247.974 78.4722 247.986 78.4646 248C78.4536 248.019 78.445 248.039 78.434 248.059C78.412 248.099 78.3905 248.14 78.3708 248.181C78.3541 248.215 78.3384 248.249 78.3228 248.284C78.3043 248.325 78.2869 248.366 78.2707 248.407C78.2631 248.426 78.2545 248.444 78.2475 248.462C78.2411 248.479 78.2371 248.496 78.2307 248.512C78.2168 248.551 78.2041 248.591 78.1913 248.63C78.1803 248.666 78.1693 248.701 78.1601 248.737C78.1491 248.777 78.1398 248.817 78.1311 248.857C78.1265 248.878 78.1195 248.899 78.1155 248.921C78.1126 248.935 78.1114 248.95 78.1085 248.964C78.101 249.005 78.0952 249.046 78.0894 249.086C78.0848 249.122 78.0796 249.158 78.0761 249.193C78.0721 249.234 78.0697 249.275 78.0674 249.316C78.0663 249.34 78.0628 249.364 78.0622 249.388C78.0616 249.412 78.0611 249.436 78.0611 249.46L78.0391 257.192C78.0391 257.145 78.0425 257.097 78.0454 257.049C78.0489 257.006 78.0512 256.965 78.0553 256.924Z",
    fill: "url(#paint120_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.311 254.474L99.7813 254.73C99.6435 254.85 99.4999 254.968 99.3517 255.085C99.3036 255.122 99.2527 255.159 99.2035 255.197C99.1016 255.275 98.9985 255.353 98.892 255.43C98.83 255.474 98.7657 255.517 98.7026 255.561C98.603 255.63 98.5034 255.698 98.3998 255.766C98.3303 255.811 98.2585 255.855 98.1867 255.9C98.0501 255.986 97.9134 256.072 97.7698 256.155C97.3876 256.378 96.991 256.585 96.5822 256.78C96.1729 256.975 95.7508 257.156 95.3182 257.324L94.9025 262.266L89.8574 263.05L85.1812 258.896C84.8159 258.882 84.4511 258.858 84.0875 258.83C83.9861 258.822 83.8848 258.814 83.784 258.805C83.6503 258.793 83.5165 258.78 83.3828 258.767C83.2542 258.753 83.1263 258.739 82.9989 258.724C82.8657 258.709 82.7331 258.691 82.6005 258.674C82.4749 258.657 82.3498 258.64 82.2247 258.622C82.0823 258.601 81.9404 258.578 81.7986 258.555C81.6781 258.535 81.5577 258.515 81.4378 258.494C81.296 258.468 81.1553 258.441 81.0146 258.413C80.8988 258.391 80.783 258.368 80.6677 258.344C80.4859 258.306 80.3058 258.264 80.1258 258.222C80.0372 258.201 79.948 258.181 79.86 258.16C79.6052 258.097 79.3528 258.03 79.1026 257.959C79.0899 257.956 79.0772 257.953 79.065 257.95L71.5973 260.16L71.6158 253.649C70.6587 252.531 70.1052 251.326 69.9598 250.108L62.773 247.413L62.751 255.145L69.9378 257.841C70.009 258.437 70.1793 259.029 70.4456 259.61L67.7584 258.058L67.7364 265.791L71.4439 267.931L79.0436 265.682C79.0453 265.683 79.047 265.684 79.0488 265.684C79.0598 265.687 79.0708 265.69 79.0812 265.693C79.3313 265.764 79.5838 265.83 79.8386 265.893C79.9266 265.915 80.0158 265.934 80.1043 265.955C80.2844 265.997 80.4645 266.039 80.6463 266.077C80.6811 266.085 80.7146 266.094 80.7494 266.101C80.8299 266.117 80.9121 266.131 80.9926 266.147C81.1333 266.175 81.2746 266.202 81.4164 266.227C81.5363 266.249 81.6567 266.268 81.7771 266.288C81.919 266.311 82.0609 266.334 82.2033 266.355C82.2537 266.363 82.3035 266.372 82.3544 266.379C82.4291 266.389 82.5044 266.398 82.5797 266.407C82.7123 266.425 82.8449 266.442 82.978 266.458C83.106 266.473 83.234 266.487 83.3619 266.5C83.4957 266.514 83.6289 266.527 83.7632 266.539C83.8194 266.544 83.8755 266.55 83.9317 266.555C83.9763 266.559 84.0214 266.56 84.0666 266.563C84.4302 266.592 84.7944 266.615 85.1604 266.629L89.8366 270.783L94.8816 270L95.2974 265.057C96.1636 264.721 96.9852 264.332 97.7495 263.888C97.8283 263.842 97.9065 263.796 97.9835 263.75C98.046 263.711 98.1051 263.673 98.1659 263.634C98.2377 263.589 98.31 263.544 98.3801 263.498C98.4832 263.431 98.5828 263.363 98.6818 263.295C98.7455 263.251 98.8103 263.207 98.8723 263.163C98.9788 263.086 99.0807 263.009 99.1826 262.931C99.2324 262.893 99.284 262.856 99.3326 262.817C99.4803 262.701 99.6238 262.583 99.7617 262.463L108.291 262.207L109.627 259.283L109.649 251.55L108.311 254.474Z",
    fill: "url(#paint121_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.7695 256.156C97.0052 256.6 96.1835 256.989 95.3173 257.325L94.9016 262.267L89.8565 263.051L85.1803 258.897C83.0767 258.817 80.9969 258.501 79.0635 257.95L71.4638 260.199L67.7563 258.059L71.6144 253.649C70.6572 252.531 70.1037 251.326 69.9583 250.109L62.7715 247.413L64.1073 244.489L72.6386 244.231C73.2182 243.729 73.8859 243.252 74.6502 242.808C75.4145 242.364 76.2361 241.976 77.1023 241.637L77.5169 236.696L82.562 235.913L87.2382 240.067C89.3418 240.147 91.4234 240.463 93.3585 241.013L100.956 238.765L104.664 240.906L100.806 245.315C101.764 246.433 102.315 247.637 102.461 248.855L109.648 251.55L108.312 254.475L99.7822 254.731C99.202 255.235 98.5338 255.712 97.7695 256.156ZM80.4671 252.818C83.6586 254.661 88.8178 254.661 91.9885 252.818C95.1592 250.976 95.1424 247.988 91.9509 246.145C88.7593 244.302 83.6002 244.302 80.4294 246.145C77.2587 247.988 77.2755 250.975 80.4671 252.818Z",
    fill: "url(#paint122_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6987 236.663L72.7825 241.867L78.5705 245.23L72.4867 240.026L66.6987 236.663Z",
    fill: "url(#paint123_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.7407 197.081C90.9341 196.613 89.8177 196.679 88.5856 197.39L62.53 212.433C60.079 213.848 58.0993 217.273 58.1074 220.09L58.1538 236.489C58.1578 237.888 58.6512 238.873 59.4479 239.335L65.2358 242.699C64.4397 242.236 63.9458 241.252 63.9417 239.852L63.8954 223.453C63.8873 220.637 65.867 217.212 68.318 215.797L94.3735 200.754C95.6057 200.042 96.7226 199.976 97.5286 200.445L91.7407 197.081Z",
    fill: "url(#paint124_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.3736 200.754C96.8218 199.341 98.8142 200.473 98.8217 203.289L98.868 219.688C98.8762 222.505 96.8965 225.933 94.4489 227.347L78.5454 236.528L78.5703 245.23L72.4865 240.027L68.3934 242.39C65.9424 243.805 63.95 242.669 63.9419 239.853L63.8955 223.454C63.8874 220.637 65.8671 217.212 68.3181 215.797L94.3736 200.754Z",
    fill: "#377DB4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1749 226.145C73.1749 227.215 72.4192 228.518 71.4876 229.056C70.5559 229.594 69.8003 229.163 69.8003 228.094C69.8003 227.024 70.5559 225.721 71.4876 225.183C72.4192 224.646 73.1749 225.076 73.1749 226.145Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6177 222.425C79.6177 223.495 78.8621 224.798 77.9304 225.336C76.9988 225.874 76.2432 225.443 76.2432 224.374C76.2432 223.304 76.9988 222.002 77.9304 221.463C78.8621 220.925 79.6177 221.356 79.6177 222.425Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0606 218.706C86.0606 219.775 85.305 221.078 84.3733 221.617C83.4411 222.155 82.686 221.724 82.686 220.654C82.686 219.585 83.4417 218.282 84.3733 217.744C85.305 217.206 86.0606 217.636 86.0606 218.706Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.503 214.986C92.503 216.056 91.7473 217.358 90.8157 217.897C89.8835 218.435 89.1284 218.004 89.1284 216.935C89.1284 215.865 89.884 214.562 90.8157 214.024C91.7479 213.486 92.503 213.917 92.503 214.986Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.864 170.186L226.843 177.691C226.834 181.01 224.652 184.324 220.295 186.856C211.525 191.952 197.256 191.953 188.428 186.856C183.986 184.291 181.767 180.924 181.777 177.562L181.798 170.057C181.789 173.418 184.007 176.785 188.45 179.351C197.277 184.447 211.546 184.447 220.317 179.351C224.674 176.818 226.855 173.504 226.864 170.186Z",
    fill: "url(#paint125_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.213 160.892C229.041 165.988 229.087 174.254 220.317 179.35C211.546 184.447 197.277 184.448 188.449 179.35C179.622 174.254 179.575 165.988 188.346 160.892C197.116 155.795 211.385 155.795 220.213 160.892Z",
    fill: "url(#paint126_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.215 161.504L194.353 164.237C191.973 164.601 191.379 167.759 193.464 168.963L206.592 176.542C207.892 177.293 209.555 176.763 210.181 175.399L214.915 165.086C215.762 163.242 214.22 161.197 212.215 161.504Z",
    fill: "url(#paint127_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.438 298.501L170.3 310.785C168.83 311.64 166.442 311.641 164.962 310.787L123.291 286.683C122.546 286.253 122.175 285.689 122.176 285.125L122.167 288.215C122.165 288.779 122.538 289.343 123.282 289.773L164.953 313.878C166.433 314.732 168.821 314.73 170.291 313.876L191.429 301.592C192.16 301.167 192.525 300.613 192.527 300.057L192.536 296.967C192.534 297.522 192.168 298.077 191.438 298.501Z",
    fill: "url(#paint128_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.421 295.411C192.901 296.266 192.908 297.647 191.438 298.501L170.3 310.785C168.83 311.64 166.441 311.642 164.961 310.787L123.291 286.683C121.811 285.829 121.803 284.444 123.273 283.589L144.411 271.305C145.881 270.45 148.27 270.453 149.75 271.307L191.421 295.411Z",
    fill: "url(#paint129_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.57 295.213L149.478 272.752C148.164 271.993 146.043 271.991 144.737 272.75L141.935 274.378L142.273 274.751C142.659 275.176 142.553 275.85 142.055 276.137L134.479 280.511C134.264 280.636 134.006 280.665 133.767 280.594L132.106 280.092L125.965 283.66C124.659 284.419 124.666 285.65 125.981 286.408L165.072 308.87C166.387 309.629 168.508 309.627 169.813 308.869L188.585 297.96C189.89 297.199 189.884 295.972 188.57 295.213Z",
    fill: "url(#paint130_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.296 185.563L148.678 151.996",
    stroke: "#123A8E",
    strokeWidth: 1.8707,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.17 128.388C166.614 127.483 164.459 127.611 162.08 128.984C161.682 129.213 161.289 129.477 160.905 129.758L163.959 131.533C164.342 131.251 164.736 130.989 165.134 130.759C167.513 129.385 169.668 129.258 171.224 130.162L168.17 128.388Z",
    fill: "url(#paint131_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.447 123.332C156.89 122.428 154.735 122.555 152.358 123.927C148.201 126.327 144.746 131.733 143.984 136.694C143.528 136.882 143.064 137.109 142.591 137.383C139.88 138.948 137.428 141.629 135.66 144.699C134.909 144.739 134.072 145.004 133.193 145.511C129.884 147.422 127.209 152.05 127.22 155.852C127.224 157.283 127.608 158.39 128.262 159.116C127.542 160.499 127.106 162 127.11 163.371C127.114 164.878 127.646 165.94 128.505 166.438L131.559 168.213C130.7 167.714 130.168 166.653 130.164 165.145C130.16 163.775 130.596 162.273 131.315 160.891C130.662 160.165 130.278 159.058 130.274 157.627C130.263 153.825 132.937 149.196 136.247 147.286C137.125 146.779 137.963 146.514 138.714 146.474C140.482 143.403 142.933 140.723 145.644 139.157C146.118 138.884 146.582 138.656 147.038 138.468C147.8 133.507 151.255 128.102 155.411 125.702C157.789 124.33 159.944 124.202 161.5 125.107L158.447 123.332Z",
    fill: "url(#paint132_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.411 125.703C160.135 122.976 163.982 125.164 163.997 130.596C163.998 130.905 163.981 131.217 163.958 131.534C164.341 131.252 164.736 130.989 165.133 130.759C169.86 128.03 173.704 130.221 173.72 135.652C173.735 141.084 169.916 147.698 165.189 150.427L134.961 167.88C132.319 169.405 130.172 168.181 130.163 165.145C130.159 163.775 130.595 162.273 131.315 160.891C130.662 160.165 130.277 159.058 130.273 157.627C130.262 153.825 132.937 149.196 136.246 147.286C137.125 146.779 137.962 146.514 138.714 146.474C140.482 143.404 142.933 140.723 145.644 139.158C146.118 138.884 146.581 138.656 147.038 138.469C147.8 133.507 151.255 128.102 155.411 125.703Z",
    fill: "url(#paint133_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.098 131.255C174.785 130.492 172.967 130.6 170.96 131.758C170.624 131.952 170.291 132.174 169.968 132.411L172.544 133.909C172.868 133.671 173.2 133.449 173.536 133.255C175.543 132.097 177.362 131.989 178.675 132.752L176.098 131.255Z",
    fill: "url(#paint134_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.893 126.989C166.58 126.226 164.761 126.333 162.755 127.491C159.248 129.516 156.333 134.077 155.69 138.263C155.304 138.422 154.913 138.614 154.514 138.845C152.227 140.166 150.158 142.427 148.666 145.018C148.032 145.052 147.326 145.276 146.585 145.703C143.793 147.315 141.536 151.221 141.545 154.429C141.548 155.636 141.873 156.571 142.424 157.183C141.816 158.349 141.449 159.616 141.452 160.773C141.456 162.045 141.905 162.94 142.629 163.361L145.206 164.858C144.482 164.437 144.033 163.542 144.029 162.27C144.025 161.113 144.393 159.847 145 158.68C144.449 158.068 144.125 157.133 144.122 155.927C144.113 152.718 146.37 148.813 149.162 147.201C149.903 146.773 150.609 146.549 151.243 146.516C152.735 143.925 154.804 141.663 157.091 140.342C157.491 140.112 157.882 139.92 158.267 139.76C158.91 135.575 161.825 131.014 165.332 128.989C167.338 127.831 169.157 127.723 170.471 128.486L167.893 126.989Z",
    fill: "url(#paint135_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.332 128.989C169.317 126.688 172.563 128.535 172.577 133.118C172.577 133.379 172.563 133.642 172.544 133.909C172.867 133.672 173.2 133.45 173.535 133.256C177.524 130.953 180.767 132.802 180.78 137.384C180.793 141.967 177.571 147.549 173.582 149.851L148.076 164.577C145.847 165.864 144.035 164.831 144.028 162.27C144.025 161.113 144.393 159.847 145 158.68C144.449 158.068 144.124 157.134 144.122 155.927C144.112 152.719 146.369 148.813 149.161 147.201C149.903 146.773 150.609 146.55 151.243 146.517C152.735 143.926 154.803 141.664 157.091 140.343C157.49 140.112 157.882 139.921 158.267 139.761C158.91 135.575 161.825 131.013 165.332 128.989Z",
    fill: "url(#paint136_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.078 241.396L263.364 212.363C264.698 211.593 265.789 209.508 265.789 207.729V167.409C265.789 165.631 264.698 164.806 263.364 165.576L213.078 194.609C211.744 195.379 210.653 197.464 210.653 199.243V239.563C210.653 241.341 211.744 242.166 213.078 241.396Z",
    fill: "url(#paint137_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.267 194.5L263.175 165.685C264.613 164.855 265.789 165.526 265.789 167.176V172.151L210.653 203.984V199.009C210.653 197.359 211.829 195.33 213.267 194.5Z",
    fill: "url(#paint138_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.384 171.813C259.384 172.44 259.827 172.692 260.373 172.377C260.919 172.062 261.361 171.298 261.361 170.672C261.361 170.046 260.919 169.793 260.373 170.109C259.827 170.424 259.384 171.187 259.384 171.813Z",
    fill: "url(#paint139_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.396 174.116C255.396 174.743 255.839 174.995 256.385 174.68C256.931 174.365 257.373 173.601 257.373 172.975C257.373 172.348 256.931 172.096 256.385 172.412C255.839 172.727 255.396 173.49 255.396 174.116Z",
    fill: "url(#paint140_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.408 176.419C251.408 177.045 251.85 177.298 252.396 176.982C252.942 176.667 253.385 175.904 253.385 175.278C253.385 174.652 252.942 174.399 252.396 174.714C251.851 175.029 251.408 175.792 251.408 176.419Z",
    fill: "url(#paint141_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.915 234.783L261.679 207.997C262.525 207.508 263.217 206.186 263.217 205.057V179.48C263.217 178.352 262.525 177.829 261.679 178.317L216.915 205.103C216.069 205.592 215.376 206.915 215.376 208.043V233.62C215.376 234.748 216.069 235.272 216.915 234.783Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.546 275.791L249.06 240.043L287.207 262.067L225.693 297.815L187.546 275.791Z",
    fill: "url(#paint142_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.692 297.815L287.207 262.067L287.198 265.245L225.683 300.994L225.692 297.815Z",
    fill: "url(#paint143_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.67 230.791L187.546 275.791L225.693 297.815L225.683 300.994L184.773 277.374L184.906 229.195L187.67 230.791Z",
    fill: "url(#paint144_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.67 230.791L249.184 195.043L249.06 240.043L187.546 275.791L187.67 230.791Z",
    fill: "url(#paint145_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.615 231.914L247.226 198.434L247.115 238.92L189.503 272.4L189.615 231.914Z",
    fill: "url(#paint146_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.906 229.195L246.421 193.447L249.184 195.043L187.67 230.791L184.906 229.195Z",
    fill: "url(#paint147_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.274 274.293L195.711 275.773L198.29 277.262L200.854 275.782L198.274 274.293Z",
    fill: "url(#paint148_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.898 275.18L204.462 273.7L201.882 272.211L199.319 273.691L201.898 275.18Z",
    fill: "url(#paint149_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.505 273.097L208.069 271.617L205.489 270.128L202.926 271.608L205.505 273.097Z",
    fill: "url(#paint150_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.113 271.014L211.677 269.534L209.097 268.044L206.534 269.524L209.113 271.014Z",
    fill: "url(#paint151_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.704 265.962L210.141 267.442L212.721 268.931L215.284 267.451L212.704 265.962Z",
    fill: "url(#paint152_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.312 263.879L213.749 265.359L216.329 266.848L218.892 265.368L216.312 263.879Z",
    fill: "url(#paint153_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.92 261.796L217.356 263.276L219.936 264.765L222.499 263.285L219.92 261.796Z",
    fill: "url(#paint154_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.528 259.713L220.964 261.193L223.544 262.683L226.107 261.203L223.528 259.713Z",
    fill: "url(#paint155_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.135 257.631L224.571 259.11L227.151 260.599L229.714 259.119L227.135 257.631Z",
    fill: "url(#paint156_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.743 255.547L228.18 257.027L230.759 258.517L233.323 257.037L230.743 255.547Z",
    fill: "url(#paint157_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.367 256.434L236.93 254.954L234.35 253.465L231.787 254.945L234.367 256.434Z",
    fill: "url(#paint158_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.975 254.351L240.538 252.871L237.958 251.382L235.395 252.862L237.975 254.351Z",
    fill: "url(#paint159_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.582 252.268L244.145 250.788L241.565 249.299L239.002 250.779L241.582 252.268Z",
    fill: "url(#paint160_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.189 250.185L247.753 248.705L245.173 247.216L242.61 248.696L245.189 250.185Z",
    fill: "url(#paint161_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.218 246.613L248.797 248.102L251.36 246.622L248.781 245.133L246.218 246.613Z",
    fill: "url(#paint162_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.985 277.539L208.549 276.059L205.97 274.57L203.406 276.05L205.985 277.539Z",
    fill: "url(#paint163_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.593 275.457L212.156 273.977L209.577 272.487L207.013 273.967L209.593 275.457Z",
    fill: "url(#paint164_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.2 273.374L215.763 271.894L213.184 270.405L210.621 271.885L213.2 273.374Z",
    fill: "url(#paint165_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.792 268.322L214.229 269.801L216.808 271.29L219.371 269.811L216.792 268.322Z",
    fill: "url(#paint166_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.4 266.239L217.836 267.719L220.415 269.208L222.979 267.728L220.4 266.239Z",
    fill: "url(#paint167_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.007 264.156L221.444 265.636L224.023 267.125L226.587 265.645L224.007 264.156Z",
    fill: "url(#paint168_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.615 262.073L225.052 263.553L227.631 265.042L230.194 263.562L227.615 262.073Z",
    fill: "url(#paint169_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.222 259.99L228.659 261.47L231.238 262.959L233.802 261.479L231.222 259.99Z",
    fill: "url(#paint170_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.83 257.907L232.267 259.387L234.846 260.876L237.409 259.397L234.83 257.907Z",
    fill: "url(#paint171_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.454 258.793L241.017 257.313L238.437 255.825L235.874 257.304L238.454 258.793Z",
    fill: "url(#paint172_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.061 256.711L244.625 255.231L242.046 253.741L239.482 255.221L242.061 256.711Z",
    fill: "url(#paint173_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.669 254.628L248.232 253.148L245.653 251.659L243.089 253.139L245.669 254.628Z",
    fill: "url(#paint174_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.276 252.545L251.84 251.065L249.261 249.576L246.697 251.056L249.276 252.545Z",
    fill: "url(#paint175_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.884 250.462L255.448 248.982L252.868 247.493L250.305 248.973L252.884 250.462Z",
    fill: "url(#paint176_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.493 278.41L206.449 279.013L202.362 276.653L199.798 278.133L203.886 280.493L205.12 281.206L206.465 281.982L210.073 279.899L211.952 278.814L212.636 278.419L210.056 276.93L209.373 277.325L207.493 278.41Z",
    fill: "url(#paint177_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.68 277.816L216.243 276.336L213.664 274.847L211.101 276.327L213.68 277.816Z",
    fill: "url(#paint178_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.288 275.733L219.851 274.253L217.271 272.764L214.708 274.244L217.288 275.733Z",
    fill: "url(#paint179_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.879 270.681L218.316 272.161L220.895 273.651L223.459 272.171L220.879 270.681Z",
    fill: "url(#paint180_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.487 268.599L221.923 270.079L224.503 271.568L227.066 270.088L224.487 268.599Z",
    fill: "url(#paint181_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.095 266.516L225.531 267.996L228.111 269.485L230.674 268.005L228.095 266.516Z",
    fill: "url(#paint182_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.702 264.433L229.138 265.913L231.718 267.402L234.281 265.922L231.702 264.433Z",
    fill: "url(#paint183_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.309 262.35L232.746 263.83L235.326 265.319L237.889 263.839L235.309 262.35Z",
    fill: "url(#paint184_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.917 260.267L236.354 261.747L238.933 263.236L241.496 261.756L238.917 260.267Z",
    fill: "url(#paint185_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.541 261.154L245.104 259.674L242.525 258.184L239.961 259.664L242.541 261.154Z",
    fill: "url(#paint186_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.148 259.071L248.712 257.591L246.132 256.102L243.569 257.582L246.148 259.071Z",
    fill: "url(#paint187_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.756 256.988L252.32 255.508L249.74 254.018L247.177 255.498L249.756 256.988Z",
    fill: "url(#paint188_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.364 254.905L255.927 253.425L253.348 251.936L250.784 253.416L253.364 254.905Z",
    fill: "url(#paint189_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.972 252.822L259.535 251.342L256.955 249.853L254.392 251.333L256.972 252.822Z",
    fill: "url(#paint190_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.552 284.342L213.115 282.862L210.536 281.373L207.973 282.853L210.552 284.342Z",
    fill: "url(#paint191_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.16 282.259L216.723 280.779L214.143 279.29L211.58 280.77L214.16 282.259Z",
    fill: "url(#paint192_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.767 280.176L220.33 278.696L217.751 277.207L215.188 278.687L217.767 280.176Z",
    fill: "url(#paint193_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.375 278.093L223.938 276.613L221.359 275.124L218.795 276.604L221.375 278.093Z",
    fill: "url(#paint194_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.967 273.041L222.403 274.521L224.982 276.01L227.546 274.53L224.967 273.041Z",
    fill: "url(#paint195_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.574 270.958L226.011 272.438L228.59 273.927L231.154 272.447L228.574 270.958Z",
    fill: "url(#paint196_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.182 268.875L229.619 270.355L232.198 271.845L234.761 270.365L232.182 268.875Z",
    fill: "url(#paint197_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.789 266.793L233.226 268.273L235.805 269.762L238.368 268.282L235.789 266.793Z",
    fill: "url(#paint198_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.397 264.71L236.833 266.19L239.412 267.679L241.976 266.199L239.397 264.71Z",
    fill: "url(#paint199_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.004 262.626L240.441 264.106L243.02 265.596L245.584 264.116L243.004 262.626Z",
    fill: "url(#paint200_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.628 263.513L249.191 262.033L246.612 260.544L244.049 262.024L246.628 263.513Z",
    fill: "url(#paint201_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.236 261.43L252.799 259.95L250.22 258.461L247.656 259.941L250.236 261.43Z",
    fill: "url(#paint202_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.844 259.347L256.406 257.867L253.828 256.378L251.264 257.858L253.844 259.347Z",
    fill: "url(#paint203_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.451 257.265L260.014 255.785L257.435 254.296L254.872 255.775L257.451 257.265Z",
    fill: "url(#paint204_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.059 255.182L263.621 253.702L261.042 252.213L258.479 253.692L261.059 255.182Z",
    fill: "url(#paint205_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.639 286.701L217.202 285.221L214.623 283.732L212.06 285.212L214.639 286.701Z",
    fill: "url(#paint206_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.247 284.618L220.81 283.138L218.231 281.649L215.667 283.129L218.247 284.618Z",
    fill: "url(#paint207_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.854 282.536L224.417 281.056L221.838 279.566L219.274 281.046L221.854 282.536Z",
    fill: "url(#paint208_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.462 280.453L228.025 278.973L225.446 277.484L222.882 278.964L225.462 280.453Z",
    fill: "url(#paint209_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.136 264.383L247.092 264.987L244.529 266.467L243.484 267.069L240.921 268.549L239.877 269.152L237.313 270.632L236.269 271.235L233.705 272.715L232.661 273.318L230.098 274.798L226.49 276.881L229.07 278.37L232.678 276.287L235.241 274.807L236.285 274.204L238.848 272.724L239.893 272.121L242.456 270.641L243.5 270.039L246.064 268.559L247.108 267.956L249.671 266.476L250.715 265.872L251.997 265.132L253.279 264.392L250.699 262.904L249.418 263.644L248.136 264.383Z",
    fill: "url(#paint210_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.323 263.79L256.887 262.31L254.307 260.821L251.744 262.301L254.323 263.79Z",
    fill: "url(#paint211_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.931 261.707L260.494 260.227L257.914 258.738L255.351 260.218L257.931 261.707Z",
    fill: "url(#paint212_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.538 259.624L264.101 258.144L261.522 256.655L258.958 258.135L261.538 259.624Z",
    fill: "url(#paint213_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.145 257.541L267.709 256.062L265.129 254.572L262.566 256.052L265.145 257.541Z",
    fill: "url(#paint214_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.945 273.016L246.366 283.743C245.839 284.047 245.042 284.08 244.586 283.816L234.853 278.197C234.397 277.934 234.454 277.474 234.981 277.17L253.561 266.443C254.087 266.139 254.884 266.106 255.34 266.369L265.073 271.989C265.529 272.252 265.472 272.712 264.945 273.016Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.029 279.413C160.475 280.825 162.918 283.307 164.773 286.522L161.857 288.184C160.8 286.353 159.409 284.939 158.016 284.135C156.623 283.331 155.229 283.136 154.164 283.743L151.268 278.725C153.134 277.659 155.583 278.002 158.029 279.413Z",
    fill: "url(#paint215_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.403 276.871C159.958 275.459 157.509 275.117 155.642 276.183L151.267 278.725C153.134 277.66 155.583 278.001 158.029 279.414C160.475 280.826 162.918 283.308 164.773 286.523L169.147 283.981C167.292 280.765 164.849 278.283 162.403 276.871Z",
    fill: "url(#paint216_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.06 268.216C163.003 271.069 167.939 276.084 171.69 282.58L168.775 284.242C165.823 279.129 161.937 275.181 158.047 272.935C154.156 270.689 150.262 270.145 147.29 271.838L144.394 266.82C148.169 264.671 153.118 265.362 158.06 268.216Z",
    fill: "url(#paint217_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.435 265.673C157.493 262.82 152.544 262.128 148.769 264.278L144.394 266.82C148.17 264.671 153.118 265.362 158.061 268.216C163.003 271.069 167.94 276.084 171.69 282.58L176.065 280.037C172.313 273.542 167.377 268.527 162.435 265.673Z",
    fill: "url(#paint218_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.091 257.017C165.531 261.312 172.96 268.861 178.606 278.639L175.69 280.3C170.844 271.905 164.465 265.424 158.078 261.737C151.692 258.05 145.297 257.156 140.421 259.937L137.524 254.92C143.204 251.682 150.653 252.723 158.091 257.017Z",
    fill: "url(#paint219_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.465 254.475C155.027 250.18 147.579 249.139 141.898 252.378L137.523 254.92C143.204 251.682 150.653 252.722 158.091 257.017C165.531 261.312 172.96 268.861 178.606 278.639L182.98 276.096C177.335 266.319 169.905 258.77 162.465 254.475Z",
    fill: "url(#paint220_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.746 287.318C157.365 286.959 158.222 287.01 159.168 287.556C161.048 288.641 162.566 291.271 162.56 293.431C162.557 294.504 162.179 295.259 161.568 295.614L159.527 296.8C160.138 296.445 160.517 295.69 160.52 294.616C160.526 292.456 159.007 289.826 157.127 288.741C156.181 288.195 155.324 288.144 154.705 288.504L156.746 287.318Z",
    fill: "url(#paint221_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.128 288.742C155.248 287.656 153.72 288.527 153.713 290.688C153.708 292.848 155.226 295.478 157.106 296.563C158.986 297.649 160.514 296.777 160.52 294.618C160.526 292.457 159.008 289.827 157.128 288.742Z",
    fill: "url(#paint222_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5543 281.679L70.4375 273.447L80.4077 275.048L76.5543 281.679Z",
    fill: "url(#paint223_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4075 275.048C79.913 274.76 79.2275 274.801 78.4718 275.237C76.9687 276.105 75.7556 278.206 75.7603 279.933C75.7626 280.791 76.0654 281.394 76.5535 281.678L109.17 300.632C108.682 300.349 108.379 299.745 108.377 298.888C108.372 297.161 109.585 295.059 111.088 294.191C111.844 293.755 112.529 293.714 113.024 294.002L80.4075 275.048Z",
    fill: "url(#paint224_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.088 294.192C112.59 293.325 113.812 294.02 113.817 295.747C113.822 297.473 112.607 299.576 111.105 300.444C109.602 301.312 108.381 300.614 108.376 298.888C108.372 297.161 109.585 295.06 111.088 294.192Z",
    fill: "url(#paint225_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1832 273.888L70.4375 273.448L72.101 275.686C72.6187 275.21 73.0003 274.59 73.1832 273.888Z",
    fill: "url(#paint226_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.52,
    d: "M110.338 294.748L77.8863 275.65C76.8284 276.528 76.0056 277.978 75.8076 279.324L108.451 298.121C108.674 296.892 109.4 295.6 110.338 294.748Z",
    fill: "url(#paint227_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.661 306.222L75.1298 323.964C74.4674 324.349 73.3881 324.349 72.7211 323.964L32.5101 300.748C32.1743 300.554 32.007 300.3 32.0075 300.046L32 302.793C31.9994 303.047 32.1668 303.302 32.5026 303.495L72.7135 326.711C73.3806 327.096 74.4599 327.096 75.1223 326.711L105.653 308.969C105.982 308.778 106.147 308.527 106.148 308.276L106.155 305.529C106.155 305.78 105.99 306.03 105.661 306.222Z",
    fill: "url(#paint228_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.653 304.826C106.32 305.211 106.324 305.837 105.661 306.222L75.1306 323.964C74.4682 324.349 73.3889 324.349 72.7219 323.964L32.5109 300.748C31.8439 300.363 31.8404 299.738 32.5028 299.353L63.0336 281.61C63.696 281.225 64.7753 281.225 65.4424 281.61L105.653 304.826Z",
    fill: "url(#paint229_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7261 288.693L44.1437 304.041L42.5322 303.11L69.1147 287.762L70.7261 288.693Z",
    fill: "url(#paint230_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0216 291.172L48.4386 306.52L46.8271 305.59L73.4102 290.242L75.0216 291.172Z",
    fill: "url(#paint231_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.3165 293.652L52.7335 309L51.1221 308.069L77.7051 292.722L79.3165 293.652Z",
    fill: "url(#paint232_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6113 296.132L57.0289 311.479L55.4175 310.549L81.9999 295.202L83.6113 296.132Z",
    fill: "url(#paint233_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.9064 298.612L61.3239 313.959L59.7119 313.029L86.2949 297.681L87.9064 298.612Z",
    fill: "url(#paint234_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.2018 301.092L65.6187 316.439L64.0073 315.509L90.5903 300.161L92.2018 301.092Z",
    fill: "url(#paint235_linear_2150_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4961 303.571L69.9137 318.919L68.3022 317.988L94.8847 302.641L96.4961 303.571Z",
    fill: "url(#paint236_linear_2150_629)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2150_629",
    x: 0,
    y: 0,
    width: 320,
    height: 430,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2150_629"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2150_629",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2150_629",
    x1: 160,
    y1: 0,
    x2: 160,
    y2: 422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2150_629",
    x1: 222.357,
    y1: 109.416,
    x2: 188.435,
    y2: 165.666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2150_629",
    x1: 179.295,
    y1: 131.546,
    x2: 216.652,
    y2: 168.044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2150_629",
    x1: 222.357,
    y1: 102.976,
    x2: 188.435,
    y2: 159.226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2150_629",
    x1: 179.295,
    y1: 125.105,
    x2: 216.652,
    y2: 161.603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2150_629",
    x1: 222.357,
    y1: 96.5348,
    x2: 188.435,
    y2: 152.785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2150_629",
    x1: 184.587,
    y1: 125.4,
    x2: 227.955,
    y2: 162.327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2150_629",
    x1: 248.863,
    y1: 116.373,
    x2: 214.941,
    y2: 172.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2150_629",
    x1: 205.801,
    y1: 138.502,
    x2: 243.158,
    y2: 175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2150_629",
    x1: 248.863,
    y1: 109.933,
    x2: 214.941,
    y2: 166.182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2150_629",
    x1: 205.801,
    y1: 132.061,
    x2: 243.158,
    y2: 168.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2150_629",
    x1: 248.863,
    y1: 103.492,
    x2: 214.941,
    y2: 159.741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2150_629",
    x1: 203.764,
    y1: 124.766,
    x2: 251.856,
    y2: 168.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2150_629",
    x1: 142.605,
    y1: 138.796,
    x2: 152.18,
    y2: 237.874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2150_629",
    x1: 104.543,
    y1: 166.599,
    x2: 201.904,
    y2: 254.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0425,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#104095"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2150_629",
    x1: 115.706,
    y1: 175.348,
    x2: 162.796,
    y2: 218.671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0425,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#114096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2150_629",
    x1: 43.8043,
    y1: 148.326,
    x2: 138.615,
    y2: 178.818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0425,
    stopColor: "#4FAADD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#245790"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2150_629",
    x1: 71.6334,
    y1: 180.635,
    x2: 126.39,
    y2: 180.635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0425,
    stopColor: "#50ADE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#265C94"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2150_629",
    x1: 72.3628,
    y1: 159.764,
    x2: 112.171,
    y2: 199.571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2150_629",
    x1: 86.1848,
    y1: 145.941,
    x2: 125.992,
    y2: 185.749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2150_629",
    x1: 42.8248,
    y1: 157.139,
    x2: 87.7658,
    y2: 202.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0425,
    stopColor: "#50ACDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#255992"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2150_629",
    x1: 87.5104,
    y1: 180.578,
    x2: 100.32,
    y2: 187.282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2150_629",
    x1: 89.4991,
    y1: 176.31,
    x2: 102.521,
    y2: 183.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2150_629",
    x1: 91.6728,
    y1: 172.241,
    x2: 104.489,
    y2: 178.949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2150_629",
    x1: 92.1634,
    y1: 168.382,
    x2: 106.289,
    y2: 175.774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2150_629",
    x1: 86.8741,
    y1: 184.08,
    x2: 99.9884,
    y2: 190.943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2150_629",
    x1: 89.5511,
    y1: 179.12,
    x2: 102.24,
    y2: 185.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2150_629",
    x1: 92.3599,
    y1: 173.213,
    x2: 105.233,
    y2: 179.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2150_629",
    x1: 88.9816,
    y1: 181.563,
    x2: 102.55,
    y2: 188.664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2150_629",
    x1: 91.722,
    y1: 177.311,
    x2: 104.404,
    y2: 183.948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_2150_629",
    x1: 87.5825,
    y1: 185.373,
    x2: 100.372,
    y2: 192.066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_2150_629",
    x1: 89.1372,
    y1: 184.977,
    x2: 101.728,
    y2: 191.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_2150_629",
    x1: 92.51,
    y1: 177.53,
    x2: 105.527,
    y2: 184.343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_2150_629",
    x1: 110.46,
    y1: 171.954,
    x2: 112.15,
    y2: 172.675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_2150_629",
    x1: 112.566,
    y1: 170.738,
    x2: 114.256,
    y2: 171.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_2150_629",
    x1: 114.672,
    y1: 169.522,
    x2: 116.361,
    y2: 170.244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_2150_629",
    x1: 116.778,
    y1: 168.306,
    x2: 118.467,
    y2: 169.028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_2150_629",
    x1: 110.46,
    y1: 174.244,
    x2: 112.15,
    y2: 174.966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_2150_629",
    x1: 112.566,
    y1: 173.028,
    x2: 114.256,
    y2: 173.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_2150_629",
    x1: 114.672,
    y1: 171.812,
    x2: 116.361,
    y2: 172.534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_2150_629",
    x1: 116.778,
    y1: 170.596,
    x2: 118.467,
    y2: 171.318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_2150_629",
    x1: 110.46,
    y1: 176.534,
    x2: 112.15,
    y2: 177.256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_2150_629",
    x1: 112.566,
    y1: 175.318,
    x2: 114.256,
    y2: 176.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_2150_629",
    x1: 114.672,
    y1: 174.102,
    x2: 116.361,
    y2: 174.824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_2150_629",
    x1: 116.778,
    y1: 172.887,
    x2: 118.467,
    y2: 173.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_2150_629",
    x1: 110.46,
    y1: 178.825,
    x2: 112.15,
    y2: 179.546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_2150_629",
    x1: 112.566,
    y1: 177.609,
    x2: 114.256,
    y2: 178.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_2150_629",
    x1: 114.672,
    y1: 176.393,
    x2: 116.361,
    y2: 177.114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_2150_629",
    x1: 116.778,
    y1: 175.177,
    x2: 118.467,
    y2: 175.898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_2150_629",
    x1: 43.8043,
    y1: 125.005,
    x2: 138.615,
    y2: 155.497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0425,
    stopColor: "#4FAADD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#245790"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_2150_629",
    x1: 71.6334,
    y1: 157.315,
    x2: 126.39,
    y2: 157.315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0425,
    stopColor: "#50ADE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#265C94"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_2150_629",
    x1: 72.3628,
    y1: 136.443,
    x2: 112.171,
    y2: 176.251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_2150_629",
    x1: 86.1848,
    y1: 122.621,
    x2: 125.992,
    y2: 162.428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_2150_629",
    x1: 42.8248,
    y1: 133.818,
    x2: 87.7658,
    y2: 178.759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0425,
    stopColor: "#50ACDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#255992"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_2150_629",
    x1: 87.5104,
    y1: 157.257,
    x2: 100.32,
    y2: 163.961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_2150_629",
    x1: 89.4991,
    y1: 152.989,
    x2: 102.521,
    y2: 159.804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_2150_629",
    x1: 91.6728,
    y1: 148.921,
    x2: 104.489,
    y2: 155.628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_2150_629",
    x1: 92.1634,
    y1: 145.061,
    x2: 106.289,
    y2: 152.453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_2150_629",
    x1: 86.8741,
    y1: 160.759,
    x2: 99.9884,
    y2: 167.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_2150_629",
    x1: 89.5511,
    y1: 155.799,
    x2: 102.24,
    y2: 162.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_2150_629",
    x1: 92.3599,
    y1: 149.893,
    x2: 105.233,
    y2: 156.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_2150_629",
    x1: 88.9816,
    y1: 158.242,
    x2: 102.55,
    y2: 165.343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_2150_629",
    x1: 91.722,
    y1: 153.99,
    x2: 104.404,
    y2: 160.627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_2150_629",
    x1: 87.5825,
    y1: 162.052,
    x2: 100.372,
    y2: 168.745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_2150_629",
    x1: 89.1372,
    y1: 161.657,
    x2: 101.728,
    y2: 168.246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_2150_629",
    x1: 92.51,
    y1: 154.21,
    x2: 105.527,
    y2: 161.022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_2150_629",
    x1: 110.46,
    y1: 148.633,
    x2: 112.15,
    y2: 149.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_2150_629",
    x1: 112.566,
    y1: 147.417,
    x2: 114.256,
    y2: 148.139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_2150_629",
    x1: 114.672,
    y1: 146.201,
    x2: 116.361,
    y2: 146.923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_2150_629",
    x1: 116.778,
    y1: 144.985,
    x2: 118.467,
    y2: 145.707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_2150_629",
    x1: 110.46,
    y1: 150.923,
    x2: 112.15,
    y2: 151.645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_2150_629",
    x1: 112.566,
    y1: 149.707,
    x2: 114.256,
    y2: 150.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_2150_629",
    x1: 114.672,
    y1: 148.492,
    x2: 116.361,
    y2: 149.213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_2150_629",
    x1: 116.778,
    y1: 147.276,
    x2: 118.467,
    y2: 147.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_2150_629",
    x1: 110.46,
    y1: 153.214,
    x2: 112.15,
    y2: 153.935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_2150_629",
    x1: 112.566,
    y1: 151.998,
    x2: 114.256,
    y2: 152.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_2150_629",
    x1: 114.672,
    y1: 150.782,
    x2: 116.361,
    y2: 151.504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_2150_629",
    x1: 116.778,
    y1: 149.566,
    x2: 118.467,
    y2: 150.288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_2150_629",
    x1: 110.46,
    y1: 155.504,
    x2: 112.15,
    y2: 156.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_2150_629",
    x1: 112.566,
    y1: 154.288,
    x2: 114.256,
    y2: 155.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_2150_629",
    x1: 114.672,
    y1: 153.072,
    x2: 116.361,
    y2: 153.794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_2150_629",
    x1: 116.778,
    y1: 151.856,
    x2: 118.467,
    y2: 152.578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_2150_629",
    x1: 43.8043,
    y1: 103.022,
    x2: 138.615,
    y2: 133.514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0425,
    stopColor: "#4FAADD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#245790"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_2150_629",
    x1: 71.6334,
    y1: 135.332,
    x2: 126.39,
    y2: 135.332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0425,
    stopColor: "#50ADE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#265C94"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_2150_629",
    x1: 72.3628,
    y1: 114.46,
    x2: 112.171,
    y2: 154.268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_2150_629",
    x1: 86.1848,
    y1: 100.638,
    x2: 125.992,
    y2: 140.446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_2150_629",
    x1: 42.8248,
    y1: 111.836,
    x2: 87.7658,
    y2: 156.777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0425,
    stopColor: "#50ACDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#255992"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_2150_629",
    x1: 87.5104,
    y1: 135.275,
    x2: 100.32,
    y2: 141.979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_2150_629",
    x1: 89.4991,
    y1: 131.006,
    x2: 102.521,
    y2: 137.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_2150_629",
    x1: 91.6728,
    y1: 126.938,
    x2: 104.489,
    y2: 133.645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_2150_629",
    x1: 92.1634,
    y1: 123.078,
    x2: 106.289,
    y2: 130.471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_2150_629",
    x1: 86.8741,
    y1: 138.776,
    x2: 99.9884,
    y2: 145.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_2150_629",
    x1: 89.5511,
    y1: 133.816,
    x2: 102.24,
    y2: 140.457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_2150_629",
    x1: 92.3599,
    y1: 127.91,
    x2: 105.233,
    y2: 134.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_2150_629",
    x1: 88.9816,
    y1: 136.259,
    x2: 102.55,
    y2: 143.361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_2150_629",
    x1: 91.722,
    y1: 132.007,
    x2: 104.404,
    y2: 138.644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_2150_629",
    x1: 87.5825,
    y1: 140.069,
    x2: 100.372,
    y2: 146.763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_2150_629",
    x1: 89.1372,
    y1: 139.674,
    x2: 101.728,
    y2: 146.264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_2150_629",
    x1: 92.51,
    y1: 132.227,
    x2: 105.527,
    y2: 139.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_2150_629",
    x1: 110.46,
    y1: 126.65,
    x2: 112.15,
    y2: 127.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_2150_629",
    x1: 112.566,
    y1: 125.435,
    x2: 114.256,
    y2: 126.156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_2150_629",
    x1: 114.672,
    y1: 124.219,
    x2: 116.361,
    y2: 124.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_2150_629",
    x1: 116.778,
    y1: 123.003,
    x2: 118.467,
    y2: 123.724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_2150_629",
    x1: 110.46,
    y1: 128.941,
    x2: 112.15,
    y2: 129.662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_2150_629",
    x1: 112.566,
    y1: 127.725,
    x2: 114.256,
    y2: 128.446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_2150_629",
    x1: 114.672,
    y1: 126.509,
    x2: 116.361,
    y2: 127.231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_2150_629",
    x1: 116.778,
    y1: 125.293,
    x2: 118.467,
    y2: 126.015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_2150_629",
    x1: 110.46,
    y1: 131.231,
    x2: 112.15,
    y2: 131.953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_2150_629",
    x1: 112.566,
    y1: 130.015,
    x2: 114.256,
    y2: 130.737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_2150_629",
    x1: 114.672,
    y1: 128.799,
    x2: 116.361,
    y2: 129.521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_2150_629",
    x1: 116.778,
    y1: 127.583,
    x2: 118.467,
    y2: 128.305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_2150_629",
    x1: 110.46,
    y1: 133.521,
    x2: 112.15,
    y2: 134.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_2150_629",
    x1: 112.566,
    y1: 132.305,
    x2: 114.256,
    y2: 133.027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_2150_629",
    x1: 114.672,
    y1: 131.089,
    x2: 116.361,
    y2: 131.811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_2150_629",
    x1: 116.778,
    y1: 129.873,
    x2: 118.467,
    y2: 130.595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_2150_629",
    x1: 116.18,
    y1: 261.422,
    x2: 118.979,
    y2: 261.422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_2150_629",
    x1: 99.7738,
    y1: 264.039,
    x2: 111.543,
    y2: 264.039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_2150_629",
    x1: 88.7437,
    y1: 269.3,
    x2: 122.574,
    y2: 269.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_2150_629",
    x1: 88.7592,
    y1: 263.051,
    x2: 122.573,
    y2: 263.051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0425,
    stopColor: "#E3EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#387FB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_2150_629",
    x1: 100.784,
    y1: 246.976,
    x2: 104.664,
    y2: 246.976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_2150_629",
    x1: 78.0403,
    y1: 251.002,
    x2: 94.3557,
    y2: 251.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_2150_629",
    x1: 62.7497,
    y1: 259.098,
    x2: 109.647,
    y2: 259.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_2150_629",
    x1: 62.7713,
    y1: 249.481,
    x2: 109.647,
    y2: 249.481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0425,
    stopColor: "#E3EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#387FB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_2150_629",
    x1: 66.6985,
    y1: 240.946,
    x2: 78.5703,
    y2: 240.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_2150_629",
    x1: 58.1072,
    y1: 219.74,
    x2: 97.5286,
    y2: 219.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_2150_629",
    x1: 181.777,
    y1: 180.368,
    x2: 226.864,
    y2: 180.368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0425,
    stopColor: "#408DC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3980B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_2150_629",
    x1: 181.798,
    y1: 170.121,
    x2: 226.864,
    y2: 170.121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_2150_629",
    x1: 174.028,
    y1: 170.681,
    x2: 222.475,
    y2: 176.706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_2150_629",
    x1: 122.167,
    y1: 299.821,
    x2: 192.536,
    y2: 299.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_2150_629",
    x1: 122.175,
    y1: 291.046,
    x2: 192.535,
    y2: 291.046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0425,
    stopColor: "#E3EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#978EF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_2150_629",
    x1: 124.99,
    y1: 290.809,
    x2: 189.56,
    y2: 290.809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_2150_629",
    x1: 166.064,
    y1: 89.282,
    x2: 166.064,
    y2: 180.938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_2150_629",
    x1: 144.305,
    y1: 89.2819,
    x2: 144.305,
    y2: 180.938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_2150_629",
    x1: 133.184,
    y1: 130.939,
    x2: 198.764,
    y2: 196.519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0425,
    stopColor: "#E3EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A81B7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_2150_629",
    x1: 174.321,
    y1: 98.2584,
    x2: 174.321,
    y2: 175.596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_2150_629",
    x1: 155.961,
    y1: 98.2584,
    x2: 155.961,
    y2: 175.596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_2150_629",
    x1: 146.033,
    y1: 141.698,
    x2: 244.295,
    y2: 183.046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0425,
    stopColor: "#E3EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A82B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_2150_629",
    x1: 274.892,
    y1: 182.314,
    x2: 222.505,
    y2: 164.167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0425,
    stopColor: "#E3EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCE4F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_2150_629",
    x1: 241.753,
    y1: 179.566,
    x2: 199.264,
    y2: 243.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_2150_629",
    x1: 264.712,
    y1: 162.952,
    x2: 255.662,
    y2: 174.923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_2150_629",
    x1: 260.724,
    y1: 165.255,
    x2: 251.674,
    y2: 177.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear_2150_629",
    x1: 256.735,
    y1: 167.557,
    x2: 247.686,
    y2: 179.528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_2150_629",
    x1: 187.546,
    y1: 268.929,
    x2: 287.207,
    y2: 268.929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0425,
    stopColor: "#E3EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D88BD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_2150_629",
    x1: 188.832,
    y1: 251.587,
    x2: 309.776,
    y2: 305.148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0425,
    stopColor: "#E3EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#499FD3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear_2150_629",
    x1: 184.773,
    y1: 265.094,
    x2: 225.693,
    y2: 265.094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear_2150_629",
    x1: 169.783,
    y1: 189.501,
    x2: 241.755,
    y2: 257.524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0425,
    stopColor: "#E3EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#479ACF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear_2150_629",
    x1: 173.948,
    y1: 193.437,
    x2: 239.75,
    y2: 255.628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_2150_629",
    x1: 184.906,
    y1: 212.119,
    x2: 249.184,
    y2: 212.119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0425,
    stopColor: "#E3EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E89BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_2150_629",
    x1: 191.508,
    y1: 276.168,
    x2: 201.444,
    y2: 276.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear_2150_629",
    x1: 195.115,
    y1: 274.086,
    x2: 205.051,
    y2: 274.838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint150_linear_2150_629",
    x1: 198.722,
    y1: 272.003,
    x2: 208.659,
    y2: 272.755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear_2150_629",
    x1: 202.33,
    y1: 269.92,
    x2: 212.266,
    y2: 270.672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint152_linear_2150_629",
    x1: 205.938,
    y1: 267.837,
    x2: 215.874,
    y2: 268.589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint153_linear_2150_629",
    x1: 209.545,
    y1: 265.754,
    x2: 219.482,
    y2: 266.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint154_linear_2150_629",
    x1: 213.153,
    y1: 263.671,
    x2: 223.089,
    y2: 264.423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint155_linear_2150_629",
    x1: 216.761,
    y1: 261.588,
    x2: 226.697,
    y2: 262.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint156_linear_2150_629",
    x1: 220.368,
    y1: 259.505,
    x2: 230.304,
    y2: 260.257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint157_linear_2150_629",
    x1: 223.976,
    y1: 257.423,
    x2: 233.912,
    y2: 258.175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint158_linear_2150_629",
    x1: 227.584,
    y1: 255.34,
    x2: 237.52,
    y2: 256.092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint159_linear_2150_629",
    x1: 231.191,
    y1: 253.257,
    x2: 241.128,
    y2: 254.009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint160_linear_2150_629",
    x1: 234.799,
    y1: 251.174,
    x2: 244.735,
    y2: 251.926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint161_linear_2150_629",
    x1: 238.406,
    y1: 249.091,
    x2: 248.342,
    y2: 249.843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint162_linear_2150_629",
    x1: 242.014,
    y1: 247.008,
    x2: 251.95,
    y2: 247.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint163_linear_2150_629",
    x1: 199.202,
    y1: 276.445,
    x2: 209.139,
    y2: 277.197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint164_linear_2150_629",
    x1: 202.81,
    y1: 274.362,
    x2: 212.746,
    y2: 275.114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint165_linear_2150_629",
    x1: 206.417,
    y1: 272.28,
    x2: 216.354,
    y2: 273.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint166_linear_2150_629",
    x1: 210.025,
    y1: 270.197,
    x2: 219.961,
    y2: 270.948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint167_linear_2150_629",
    x1: 213.633,
    y1: 268.114,
    x2: 223.569,
    y2: 268.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint168_linear_2150_629",
    x1: 217.24,
    y1: 266.031,
    x2: 227.177,
    y2: 266.783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint169_linear_2150_629",
    x1: 220.848,
    y1: 263.948,
    x2: 230.784,
    y2: 264.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint170_linear_2150_629",
    x1: 224.455,
    y1: 261.865,
    x2: 234.391,
    y2: 262.617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint171_linear_2150_629",
    x1: 228.063,
    y1: 259.782,
    x2: 237.999,
    y2: 260.534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint172_linear_2150_629",
    x1: 231.671,
    y1: 257.7,
    x2: 241.607,
    y2: 258.451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint173_linear_2150_629",
    x1: 235.279,
    y1: 255.617,
    x2: 245.215,
    y2: 256.369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint174_linear_2150_629",
    x1: 238.886,
    y1: 253.534,
    x2: 248.822,
    y2: 254.286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint175_linear_2150_629",
    x1: 242.493,
    y1: 251.451,
    x2: 252.43,
    y2: 252.203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint176_linear_2150_629",
    x1: 246.101,
    y1: 249.368,
    x2: 256.037,
    y2: 250.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint177_linear_2150_629",
    x1: 189.208,
    y1: 280.194,
    x2: 214.049,
    y2: 282.074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint178_linear_2150_629",
    x1: 206.897,
    y1: 276.722,
    x2: 216.833,
    y2: 277.474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint179_linear_2150_629",
    x1: 210.505,
    y1: 274.639,
    x2: 220.441,
    y2: 275.391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint180_linear_2150_629",
    x1: 214.112,
    y1: 272.557,
    x2: 224.048,
    y2: 273.308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint181_linear_2150_629",
    x1: 217.72,
    y1: 270.474,
    x2: 227.656,
    y2: 271.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint182_linear_2150_629",
    x1: 221.328,
    y1: 268.391,
    x2: 231.264,
    y2: 269.143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint183_linear_2150_629",
    x1: 224.935,
    y1: 266.308,
    x2: 234.871,
    y2: 267.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint184_linear_2150_629",
    x1: 228.542,
    y1: 264.225,
    x2: 238.479,
    y2: 264.977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint185_linear_2150_629",
    x1: 232.15,
    y1: 262.142,
    x2: 242.086,
    y2: 262.894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint186_linear_2150_629",
    x1: 235.758,
    y1: 260.059,
    x2: 245.694,
    y2: 260.811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint187_linear_2150_629",
    x1: 239.366,
    y1: 257.977,
    x2: 249.302,
    y2: 258.728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint188_linear_2150_629",
    x1: 242.973,
    y1: 255.894,
    x2: 252.909,
    y2: 256.646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint189_linear_2150_629",
    x1: 246.581,
    y1: 253.811,
    x2: 256.517,
    y2: 254.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint190_linear_2150_629",
    x1: 250.188,
    y1: 251.728,
    x2: 260.125,
    y2: 252.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint191_linear_2150_629",
    x1: 203.769,
    y1: 283.248,
    x2: 213.705,
    y2: 284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint192_linear_2150_629",
    x1: 207.377,
    y1: 281.165,
    x2: 217.313,
    y2: 281.917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint193_linear_2150_629",
    x1: 210.984,
    y1: 279.082,
    x2: 220.92,
    y2: 279.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint194_linear_2150_629",
    x1: 214.592,
    y1: 276.999,
    x2: 224.528,
    y2: 277.751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint195_linear_2150_629",
    x1: 218.199,
    y1: 274.916,
    x2: 228.136,
    y2: 275.668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint196_linear_2150_629",
    x1: 221.807,
    y1: 272.833,
    x2: 231.743,
    y2: 273.585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint197_linear_2150_629",
    x1: 225.415,
    y1: 270.751,
    x2: 235.351,
    y2: 271.503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint198_linear_2150_629",
    x1: 229.022,
    y1: 268.668,
    x2: 238.958,
    y2: 269.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint199_linear_2150_629",
    x1: 232.63,
    y1: 266.585,
    x2: 242.566,
    y2: 267.337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint200_linear_2150_629",
    x1: 236.237,
    y1: 264.502,
    x2: 246.174,
    y2: 265.254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint201_linear_2150_629",
    x1: 239.845,
    y1: 262.419,
    x2: 249.781,
    y2: 263.171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint202_linear_2150_629",
    x1: 243.453,
    y1: 260.336,
    x2: 253.389,
    y2: 261.088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint203_linear_2150_629",
    x1: 247.06,
    y1: 258.253,
    x2: 256.997,
    y2: 259.005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint204_linear_2150_629",
    x1: 250.668,
    y1: 256.171,
    x2: 260.604,
    y2: 256.922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint205_linear_2150_629",
    x1: 254.275,
    y1: 254.088,
    x2: 264.211,
    y2: 254.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint206_linear_2150_629",
    x1: 207.856,
    y1: 285.607,
    x2: 217.792,
    y2: 286.359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint207_linear_2150_629",
    x1: 211.464,
    y1: 283.524,
    x2: 221.4,
    y2: 284.276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint208_linear_2150_629",
    x1: 215.071,
    y1: 281.442,
    x2: 225.007,
    y2: 282.193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint209_linear_2150_629",
    x1: 218.679,
    y1: 279.359,
    x2: 228.615,
    y2: 280.111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint210_linear_2150_629",
    x1: 205.843,
    y1: 272.599,
    x2: 255.768,
    y2: 276.377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint211_linear_2150_629",
    x1: 247.54,
    y1: 262.696,
    x2: 257.476,
    y2: 263.448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint212_linear_2150_629",
    x1: 251.148,
    y1: 260.613,
    x2: 261.084,
    y2: 261.365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint213_linear_2150_629",
    x1: 254.755,
    y1: 258.53,
    x2: 264.691,
    y2: 259.282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint214_linear_2150_629",
    x1: 258.362,
    y1: 256.447,
    x2: 268.299,
    y2: 257.199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint215_linear_2150_629",
    x1: 151.267,
    y1: 283.142,
    x2: 164.772,
    y2: 283.142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0425,
    stopColor: "#E3EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#978EF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint216_linear_2150_629",
    x1: 151.267,
    y1: 281.04,
    x2: 169.147,
    y2: 281.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint217_linear_2150_629",
    x1: 144.394,
    y1: 274.901,
    x2: 171.69,
    y2: 274.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0425,
    stopColor: "#E3EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#978EF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint218_linear_2150_629",
    x1: 144.394,
    y1: 272.799,
    x2: 176.065,
    y2: 272.799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint219_linear_2150_629",
    x1: 137.524,
    y1: 266.662,
    x2: 178.605,
    y2: 266.662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0425,
    stopColor: "#E3EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#978EF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint220_linear_2150_629",
    x1: 137.524,
    y1: 264.56,
    x2: 182.98,
    y2: 264.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint221_linear_2150_629",
    x1: 164.693,
    y1: 264.479,
    x2: 158.215,
    y2: 293.027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint222_linear_2150_629",
    x1: 166.15,
    y1: 283.028,
    x2: 140.481,
    y2: 310.377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint223_linear_2150_629",
    x1: 68.9355,
    y1: 284.234,
    x2: 91.4944,
    y2: 251.237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint224_linear_2150_629",
    x1: 99.6693,
    y1: 279.555,
    x2: 88.2014,
    y2: 295.324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0425,
    stopColor: "#E3EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#978EF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint225_linear_2150_629",
    x1: 108.377,
    y1: 297.318,
    x2: 113.817,
    y2: 297.318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint226_linear_2150_629",
    x1: 72.5181,
    y1: 270.402,
    x2: 70.9706,
    y2: 277.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint227_linear_2150_629",
    x1: 76.1966,
    y1: 275.576,
    x2: 127.383,
    y2: 310.335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#978EF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint228_linear_2150_629",
    x1: 31.9996,
    y1: 313.523,
    x2: 106.155,
    y2: 313.523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0425,
    stopColor: "#E3EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#978EF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint229_linear_2150_629",
    x1: 75.7184,
    y1: 324.824,
    x2: 33.8919,
    y2: 185.947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint230_linear_2150_629",
    x1: 62.1345,
    y1: 297.44,
    x2: 40.2052,
    y2: 275.173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint231_linear_2150_629",
    x1: 66.4299,
    y1: 299.919,
    x2: 44.5005,
    y2: 277.653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint232_linear_2150_629",
    x1: 70.7246,
    y1: 302.399,
    x2: 48.7952,
    y2: 280.132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint233_linear_2150_629",
    x1: 75.0198,
    y1: 304.879,
    x2: 53.0905,
    y2: 282.612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint234_linear_2150_629",
    x1: 79.3147,
    y1: 307.359,
    x2: 57.3854,
    y2: 285.092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint235_linear_2150_629",
    x1: 83.6099,
    y1: 309.838,
    x2: 61.6806,
    y2: 287.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint236_linear_2150_629",
    x1: 87.9046,
    y1: 312.318,
    x2: 65.9753,
    y2: 290.052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF712F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusniessImg3);
export default __webpack_public_path__ + "static/media/busniess-Img3.2375237a75545f1c21cc65dd73d95ace.svg";
export { ForwardRef as ReactComponent };